export const ru = {
  topicCards: {
    title: 'Подбор слов по теме',
    topicLabel: 'Тема', topicPlaceholder: 'Например, работа инженера-конструктора',
    descriptionLabel: 'Описание', optional: 'необязательно',
    descriptionPlaceholder: 'Что именно: чертежи, расчёт нагрузок, металлоконструкции…',
    countLabel: 'Сколько слов',
    composePlaceholder: 'Тема — например, «кухня ресторана»',
    composePlaceholderShort: 'Тема, например «кухня»',
    descriptionAdd: '+ описание', descriptionHide: '− описание',
    genShort_one: '{{count}} жетон', genShort_few: '{{count}} жетона', genShort_many: '{{count}} жетонов', genShort_other: '{{count}} жетона',
    kindPhrase: 'фраза', kindPhrasal: 'фразовый глагол', tagUnavailable: 'нет в словаре', peekClose: 'Закрыть',
    generations_one: '{{count}} жетон', generations_few: '{{count}} жетона', generations_many: '{{count}} жетонов', generations_other: '{{count}} жетона',
    meanings_one: '{{count}} значение', meanings_few: '{{count}} значения', meanings_many: '{{count}} значений', meanings_other: '{{count}} значения',
    generate: 'Подобрать слова', newBatch: 'Новая подборка', newBatchCost: '1 жетон за 10 слов', starting: 'Запускаем…', topicRequired: 'Введи тему подборки.',
    quotaLow_one: 'Для подборки нужен {{count}} жетон — на сегодня не хватает.', quotaLow_few: 'Для подборки нужны {{count}} жетона — на сегодня не хватает.', quotaLow_many: 'Для подборки нужно {{count}} жетонов — на сегодня не хватает.', quotaLow_other: 'Для подборки нужны {{count}} жетона — на сегодня не хватает.',
    cardQuota: 'На сегодня жетоны закончились.',
    plans: 'Тарифы', alreadyRunning: 'Подборка уже создаётся — дождись её, прежде чем запускать следующую.',
    generationError: 'Не удалось запустить подборку. Проверь соединение и попробуй ещё раз — повтор не спишет жетоны дважды.',
    history: 'Подборки', historyEmpty: 'Здесь сохранятся твои подборки.',
    historyError: 'Не удалось загрузить подборки.', moreHistory: 'Ещё', loading: 'Загружаем…', retry: 'Повторить',
    results: 'Подборка', emptyTitle: 'Какая тема тебе интересна?',
    // Два шага с ценами до первой подборки и подсказки выбора (2026-10-16).
    hint1Title: 'Введи тему', hint1Text: '1 жетон за 10 слов',
    hint2Title: 'Отметь переводы', hint2Text: 'сами слова не добавятся',
    hint3Title: 'Создай карточки', hint3Text: '1 жетон за 10 переводов',
    hintExample: 'Пример: подбор 10 слов — 1 жетон, выбрано 15 переводов — 2 жетона.', hintExampleTotal: 'Всего 3 жетона',
    hintClose: 'Скрыть навсегда',
    emptyBody: 'ИИ подберёт слова по теме и проверит их по словарю. В модуль ничего не попадёт, пока ты сам не отметишь переводы.',
    notAddedYet: 'Слова ещё не в модуле: отметь переводы, которые хочешь учить, и нажми «Создать» внизу.',
    pickAbove: 'Отметь переводы выше',
    createCards_one: 'Создать {{count}} карточку · {{cost}}', createCards_few: 'Создать {{count}} карточки · {{cost}}', createCards_many: 'Создать {{count}} карточек · {{cost}}', createCards_other: 'Создать {{count}} карточки · {{cost}}',
    detailError: 'Не удалось открыть подборку', detailErrorHint: 'Она могла стать недоступна. Выбери другую слева или повтори загрузку.',
    moreOnTopic: 'Ещё слова по теме', generatingTitle: 'Подбираем слова',
    generatingBody: 'Обычно 15–40 секунд. Можно уйти со страницы — подборка сохранится.',
    failedTitle: 'Не получилось собрать подборку',
    failedBody: 'Попробуй уточнить тему или описание.',
    failedRefund: 'Жетоны за этот подбор вернулись на баланс.',
    tryAgain: 'Изменить тему',
    wordCount_one: '{{count}} слово', wordCount_few: '{{count}} слова', wordCount_many: '{{count}} слов', wordCount_other: '{{count}} слова',
    chooseModule: 'Выбери модуль в заголовке — туда добавятся карточки.', chooseModuleShort: 'Выбери модуль',
    moduleError: 'Не удалось загрузить модули.',
    partial: 'Нашли {{actual}} из {{requested}}: остальные не подтвердились по словарю или уже были в твоих подборках.',
    checking: 'Проверяем слова…', checkingCost: 'проверяем…',
    selectAll: 'Выбрать все', deselectAll: 'Снять все', nothingSelected: 'Ничего не выбрано', free: 'бесплатно',
    packHint: 'Карточки создадутся только по отмеченным переводам: 1 жетон за каждые 10, даже из разных слов. Уже готовые карточки — бесплатно.',
    createIn: 'Создать в «{{module}}»',
    bulkQuota: 'Нужно жетонов: {{required}}, доступно: {{available}}. Сними часть отметок или дождись новых жетонов.',
    bulkWorking: 'Создаём…', bulkChecking: 'Проверяем выбранное и стоимость…',
    bulkProgress: 'Отправлено {{done}} из {{total}}', bulkStay: 'не закрывай страницу',
    bulkSummary: 'Добавлено: {{added}}. Уже были в модуле или создаются: {{already}}.',
    pairLearned: 'в модуле', pairGenerating: 'создаётся', pairFree: 'бесплатно', pairUnavailable: 'Этого значения сейчас нет в словаре.',
    pickLimit: 'За раз можно создать не больше 10 значений одного слова. Сними лишние отметки.',
    availabilityError: 'Не удалось проверить значения и стоимость.', quotaError: 'Не удалось проверить доступные жетоны.',
    uncertainResult: 'Не удалось подтвердить результат. При повторе сначала проверим, добавилась ли карточка.',
    added: 'добавлено',
    toCards: 'Открыть «{{module}}»', status: { generating: 'Создаётся', ready: 'Готово', failed: 'Не получилось' },
  },
  socialReward: {
    // Строка в боковой панели над жетонами (ТЗ главной § 11).
    sidebar: {
      locked: 'Подарок за подписку',
      ready: 'Пополнение сохранено',
    },
    card: {
      lockedTitle: 'Бесплатное пополнение жетонов',
      lockedHint: 'За подписку на Telegram или VK',
      readyTitle: 'Пополнение сохранено',
      readyHint: 'Используй в любой день',
      usedTitle: 'Пополнение использовано',
      usedHint: 'Спасибо, что ты с нами!',
      unavailable: 'Статус временно недоступен',
      open: 'Получить',
      use: 'Использовать',
      hide: 'Скрыть',
    },
    kicker: 'Подарок за подписку',
    title: 'Бесплатное пополнение жетонов',
    loading: 'Проверяем статус подарка…',
    loadError: 'Не удалось загрузить статус подарка.',
    retry: 'Повторить',
    dialogIntro: 'Подпишись на Telegram или VK — подарим ещё один дневной набор жетонов. Хватит одной подписки.',
    or: 'или',
    more: 'Будь с нами и в других соцсетях',
    noUsageShort: 'Жетоны сегодня не тратились — пополнение подождёт',
    redeemedHint: 'Можно снова создавать AI-карточки',
    subscribe: 'Подписаться',
    verified: 'Подписка подтверждена',
    notMember: 'Подписка не найдена',
    check: 'Проверить подписку',
    checkAgain: 'Проверить ещё раз',
    checking: 'Проверяем…',
    connecting: 'Подключаем…',
    telegramStatus: 'Отметится само, как только вступишь',
    telegramWaiting: 'Ждём вступления в канал…',
    linksError: 'Личная ссылка не готова',
    telegramBot: 'Уже подписан? Подтвердить в боте',
    openInBrowser: 'Открыть в браузере',
    vkStatus: 'Подписка подтвердится в чате VK',
    vkWaiting: 'Нажми «Начать» в чате VK',
    vkLinked: 'Осталось проверить подписку',
    dzenStatus: 'Статьи об английском · по желанию',
    dzenOpen: 'Открыть',
    unavailable: 'Проверка временно недоступна. Попробуй позже.',
    readyTitle: 'Бесплатное пополнение сохранено',
    usedTitle: 'Подарок уже использован',
    confirmTitle: 'Пополнить жетоны сегодня?',
    confirmDescription: 'Жетоны вернутся до полного дневного набора твоего тарифа.',
    confirmOnce: 'Этот подарок можно использовать только один раз.',
    usage: 'Сегодня потрачено жетонов: {{used}} из {{limit}}',
    confirmUse: 'Да, пополнить',
    cancel: 'Назад',
    redeeming: 'Пополняем жетоны…',
    redeemedTitle: 'Жетоны пополнены',
    noUsage: 'Сегодня ты ещё не тратил жетоны. Пополнение сохранено — пригодится позже.',
    quotaError: 'Не удалось проверить жетоны. Повтори попытку.',
    linkError: 'Не удалось подтвердить аккаунт. Попробуй ещё раз.',
    accountInUse: 'Этот аккаунт соцсети уже связан с другим аккаунтом Lomora.',
    emailRequired: 'Сначала подтверди почту своего аккаунта Lomora. Кнопка отправки письма находится на главной.',
    rateLimited: 'Слишком много попыток. Подожди несколько минут и попробуй ещё раз.',
    verifyError: 'Не удалось проверить подписку. Попробуй ещё раз.',
    redeemError: 'Не удалось пополнить жетоны. Проверим статус подарка — повторная попытка не потратит его дважды.',
    notReady: 'Сначала подпишись на Telegram или VK.',
    unavailableCard: 'Подарок временно недоступен. Попробуй позже.',
  },
  training: {
    kicker: 'Тренировка',
    heroTitle: 'Выбери модуль и упражнения',
    heroSub: 'Пройди карточки и собери пары в финале.',
    start: 'Начать тренировку',
    startShort: 'Тренироваться',
    newSession: 'Выбрать другую тренировку',
    greetingSub: 'Тренируй слова из своих модулей в удобном темпе.',
    friend: 'друг',
    home: 'На главную',
    stepModule: 'Шаг 1 из 2 · модуль',
    chooseModule: 'На чём потренируемся?',
    chooseSub: 'Выбери один модуль. На следующем шаге настроишь упражнения и состав карточек.',
    cardCount_one: '{{count}} карточка',
    cardCount_few: '{{count}} карточки',
    cardCount_many: '{{count}} карточек',
    cardCount_other: '{{count}} карточки',
    loadError: 'Не удалось загрузить модули. Попробуй ещё раз.',
    resumeError: 'Не удалось проверить незавершённую тренировку. Её можно продолжить из модуля.',
    retry: 'Повторить',
    // Список модулей с планом на сегодня (решение владельца 2026-10-21): одна строка на модуль.
    words_one: '{{count}} слово',
    words_few: '{{count}} слова',
    words_many: '{{count}} слов',
    words_other: '{{count}} слова',
    rowEmpty: 'Пока нет готовых слов',
    rowUntrained_one: '{{count}} слово ещё не учили',
    rowUntrained_few: '{{count}} слова ещё не учили',
    rowUntrained_many: '{{count}} слов ещё не учили',
    rowUntrained_other: '{{count}} слова ещё не учили',
    rowToday: 'Сегодня {{count}}',
    rowMore: 'ещё {{count}}',
    rowTomorrow: 'завтра {{count}}',
    rowDone: 'Сегодня пройдено {{count}}',
    rowRepeat: 'Повторить {{count}}',
    rowNew_one: '{{count}} ещё не учили',
    rowNew_few: '{{count}} ещё не учили',
    rowNew_many: '{{count}} ещё не учили',
    rowNew_other: '{{count}} ещё не учили',
    rowNothing: 'Повторять пока нечего',
  },
  // Главная (решение владельца 2026-10-21): плашка серии по дням МСК с неделей, что повторить сегодня или
  // что завтра; на итоге тренировки — что завтра.
  today: {
    streak_one: '{{count}} день подряд',
    streak_few: '{{count}} дня подряд',
    streak_many: '{{count}} дней подряд',
    streak_other: '{{count}} дня подряд',
    week: 'Тренировки на этой неделе: {{count}} дн.',
    weekdays: 'Пн,Вт,Ср,Чт,Пт,Сб,Вс',
    // Главная «серия и что повторить» (решение владельца 2026-10-21): плашка серии, сводка дня и кнопка
    // «Тренироваться» → список модулей. «Повторить» считается по истории тренировок, не по FSRS.
    streakStart: 'Серия начнётся сегодня',
    dayCounted: 'День засчитан',
    // Новая главная (макет владельца 2026-10-22): «Тренировка на сегодня» — крупное число повторений, внизу строка
    // серии; справа в ней — когда серия даст несгораемые жетоны (вместо «до недели»).
    kicker: 'Тренировка на сегодня',
    repeatBig_one: 'слово на повторение',
    repeatBig_few: 'слова на повторение',
    repeatBig_many: 'слов на повторение',
    repeatBig_other: 'слова на повторение',
    dayPendingShort: 'Засчитается после тренировки',
    rewardTokens_one: '+{{count}} жетон',
    rewardTokens_few: '+{{count}} жетона',
    rewardTokens_many: '+{{count}} жетонов',
    rewardTokens_other: '+{{count}} жетона',
    rewardToday: 'за тренировку сегодня',
    rewardTomorrow: 'завтра',
    rewardIn_one: 'через {{count}} день',
    rewardIn_few: 'через {{count}} дня',
    rewardIn_many: 'через {{count}} дней',
    rewardIn_other: 'через {{count}} дня',
    rewardHint: 'Несгораемые жетоны за серию тренировок: они не сгорают в конце дня.',
    repeatTitle_one: 'Сегодня повторить {{count}} слово',
    repeatTitle_few: 'Сегодня повторить {{count}} слова',
    repeatTitle_many: 'Сегодня повторить {{count}} слов',
    repeatTitle_other: 'Сегодня повторить {{count}} слова',
    repeatMoreTitle_one: 'Сегодня повторить ещё {{count}} слово',
    repeatMoreTitle_few: 'Сегодня повторить ещё {{count}} слова',
    repeatMoreTitle_many: 'Сегодня повторить ещё {{count}} слов',
    repeatMoreTitle_other: 'Сегодня повторить ещё {{count}} слова',
    mistakes_one: '{{count}} с ошибкой',
    mistakes_few: '{{count}} с ошибками',
    mistakes_many: '{{count}} с ошибками',
    mistakes_other: '{{count}} с ошибками',
    stale_one: '{{count}} давно не встречалось',
    stale_few: '{{count}} давно не встречались',
    stale_many: '{{count}} давно не встречались',
    stale_other: '{{count}} давно не встречались',
    and: ' и ',
    inModules_one: 'в {{count}} модуле',
    inModules_few: 'в {{count}} модулях',
    inModules_many: 'в {{count}} модулях',
    inModules_other: 'в {{count}} модулях',
    tomorrowTitle_one: 'Завтра повторить {{count}} слово',
    tomorrowTitle_few: 'Завтра повторить {{count}} слова',
    tomorrowTitle_many: 'Завтра повторить {{count}} слов',
    tomorrowTitle_other: 'Завтра повторить {{count}} слова',
    // «Пройдено», а не «повторено»: «повторено звучит странно» (владелец, 2026-10-21).
    doneToday: 'Сегодня пройдено: {{count}}.',
    // «Завтра» — явно: строка стоит после «Сегодня пройдено» (решение владельца 2026-10-21).
    tomorrowFirst: 'Завтра первыми — {{words}}: в них были ошибки.',
    // На итогах тренировки — сразу после «Завтра повторить N слов».
    firstShort: 'первыми — {{words}}',
    doneCountTitle_one: 'Сегодня пройдено {{count}} слово',
    doneCountTitle_few: 'Сегодня пройдено {{count}} слова',
    doneCountTitle_many: 'Сегодня пройдено {{count}} слов',
    doneCountTitle_other: 'Сегодня пройдено {{count}} слова',
    newAvailable_one: 'Ещё {{count}} слово не учили.',
    newAvailable_few: 'Ещё {{count}} слова не учили.',
    newAvailable_many: 'Ещё {{count}} слов не учили.',
    newAvailable_other: 'Ещё {{count}} слова не учили.',
    addWords: 'Новые слова добавляй в строке внизу.',
    freshTitle: 'Повторять сегодня нечего',
    freshSub: 'Слова из прошлых тренировок вернутся через пару дней.',
    startNewTitle: 'Начни с новых слов',
    startNewSub_one: '{{count}} слово ждёт первой тренировки',
    startNewSub_few: '{{count}} слова ждут первой тренировки',
    startNewSub_many: '{{count}} слов ждут первой тренировки',
    startNewSub_other: '{{count}} слова ждут первой тренировки',
    emptyTitle: 'Слов для тренировки пока нет',
    emptySub: 'Добавь слово в строке внизу — оно появится здесь.',
  },
  brand: {
    name: 'Lomora',
  },
  createCard: {
    fab: 'Карточка',
    fabTitle: 'Создать карточку',
  },
  // Строка создания карточки внизу главной (widgets/HomeComposer, ТЗ главной § 14). Ключи общих частей
  // (итог выбора, цена, ошибки создания) — в cardsWorkspace.*: их видит и /cards/new.
  homeComposer: {
    label: 'Новая карточка',
    fieldAria: 'Новое слово для карточки',
    // Назначение строки — в самой подсказке (замечание владельца 2026-10-22): поле ищет слово в словаре и делает карточку.
    placeholder: 'Найти слово в словаре и создать карточку — например, travel',
    placeholderShort: 'Найти в словаре…',
    // Ручной ввод — без словаря: подсказка о словаре была бы неправдой.
    manualPlaceholder: 'Слово или фраза — например, travel',
    manualPlaceholderShort: 'Слово или фраза…',
    cyrillic: 'Нужно английское слово — например, travel',
    slow: 'связь медленная — ещё ищем…',
    collapse: 'Свернуть',
    sheetAria: 'Значения слова {{word}}',
    createShortPaid: 'Создать · 1 жетон',
    createShort: 'Создать',
    addCard: 'Добавить карточку',
    addShort: 'Добавить',
    inModule: 'в «{{title}}»',
    manualLine: 'В «{{module}}» — без ИИ: только слово и перевод. Не будет подсказки, описания значения и упражнений с предложениями.',
    manualNote: 'Ручная карточка в\u00a0«{{module}}»\u00a0— только слово и перевод',
    // «Добавить» привязал свою карточку слова из другого модуля, введённый перевод к ней не применился (ТЗ § 22.6,
    // § 18.3; приёмка A2-03). Модуль, где слово уже было, — из ответа сервера; не прислал — без названия.
    manualReused: 'Слово уже есть в\u00a0«{{module}}»\u00a0— добавили ту же карточку, свой перевод не применился.',
    manualReusedElsewhere: 'Слово уже есть в\u00a0другом модуле\u00a0— добавили ту же карточку, свой перевод не применился.',
    topicPill: 'Подобрать 10–20 слов на тему',
    manualButton: 'Вручную',
    // Почта не подтверждена: строка видна, но неактивна (решение владельца 2026-10-21).
    lockedEmail: 'Откроется после подтверждения почты',
    // Телефон уже 640 px: длинная подпись резалась на 390.
    lockedEmailShort: 'После подтверждения почты',
    // Стрелка второго ряда строки (макет B, 2026-10-21).
    chooseAria: 'Выбрать переводы',
    showAnswer: 'Показать ответ словаря',
    lookupError: 'Не удалось проверить слово. Попробуй ещё раз.',
    offline: 'Проверим слово, когда связь вернётся.',
    quotaOutPhone: 'Жетоны закончились — готовые значения и ручная карточка без жетона',
    refill: 'Пополнить за подписку',
    errors: {
      checking: 'Связь прервалась — проверяем, создались ли карточки…',
      checkFailed: 'Не можем проверить, создались ли карточки — проверим, когда вернётся связь.',
      notCreated: 'Карточки не создались — попробуй ещё раз.',
      moduleGone: 'Модуль «{{title}}» удалён — выбери другой.',
      modulesFailed: 'Модули не загрузились — попробуй ещё раз.',
      nothingAdded: 'Ничего не добавлено — уже учишь или нет в словаре.',
      notConfirmed: 'Не получилось подтвердить создание — нажми ещё раз: второй жетон не спишется.',
    },
    module: {
      aria: 'Карточки создаются в модуль «{{title}}». Сменить модуль',
      prefix: 'в модуль',
      title: 'Куда добавить карточки',
      search: 'Найти модуль',
      recent: 'Недавние',
      all: 'Все модули',
      empty: 'Ничего не нашли по «{{q}}»',
      new: 'Новый модуль',
      loading: 'Загружаем модули…',
    },
    // Сигнал у строки (ТЗ главной § 8): статус нажатия со ссылкой к записи «Недавно добавленных», пока её
    // не видно. Слово записи — отдельным элементом после подписи; «Не вышло:» — до 390 px.
    signal: {
      generating: 'Генерируем',
      slow: 'Дольше обычного:',
      ready: 'Готово:',
      added: 'Добавлено:',
      failed: 'Не получилось:',
      failedShort: 'Не вышло:',
      cards_one: '· {{count}} карточка',
      cards_few: '· {{count}} карточки',
      cards_many: '· {{count}} карточек',
      failedOf: '· {{failed}} из {{total}}',
      more: '+{{count}}',
      show: 'Показать',
      aria: 'Показать «{{title}}»',
      dismiss: 'Убрать',
      live: {
        started: 'Генерируем {{title}}',
        ready: 'Готово: {{title}}, {{cards}}',
        failed: 'Не получилось: {{title}}',
      },
    },
  },
  // Секция «Недавно добавленные» под модулями на главной (widgets/GenerationsList, ТЗ главной § 14, § 22,
  // § 23.2). В коде — «Генерации»; в текстах слова «генерация» нет, статус «генерируем» остаётся.
  generations: {
    title: 'Недавно добавленные',
    // На «Словах и модулях» — сегодняшние нажатия, где осталось что тренировать, и идущие (владелец 2026-10-28:
    // не пропадают после обновления, держатся до конца дня).
    titleVisit: 'Сегодня',
    cards_one: '{{count}} карточка',
    cards_few: '{{count}} карточки',
    cards_many: '{{count}} карточек',
    manual: 'вручную',
    topic: 'Подбор: {{topic}}',
    status: {
      generating: 'генерируем',
      progress: 'готово {{done}} из {{total}}',
      slow: 'дольше обычного',
      ready: 'готово',
      failedOf: 'не получилось: {{failed}} из {{total}}',
      failedTail: ': {{failed}} из {{total}}',
      failed: 'не получилось',
      removed: 'удалено',
    },
    time: {
      now: 'только что',
      min: '{{count}} мин',
      hour: '{{count}} ч',
      yesterday: 'вчера',
    },
    rowAria: '{{title}}, модуль «{{module}}», {{status}}, {{date}}',
    more: 'Показать ещё',
    less: 'Свернуть',
    loading: 'Загружаем…',
    loadError: 'Список не загрузился.',
    moreError: 'Не загрузилось.',
    retry: 'Повторить',
    detail: {
      error: 'Состав не загрузился.',
      gone: 'Этой записи больше нет — модуль удалён.',
    },
    // Счётчик держится с последним словом: «Фразовые / глаголы · 1», а не «· 1» один на второй строке (A2-05).
    section: {
      translations: 'Переводы',
      words: 'Слова\u00a0·\u00a0{{count}}',
      phrases: 'Фразы\u00a0·\u00a0{{count}}',
      phrasalVerbs: 'Фразовые глаголы\u00a0·\u00a0{{count}}',
      skipped: 'Не созданы\u00a0·\u00a0{{count}}',
    },
    // Строка о жетоне нажатия — по держателям жетона в составе (ТЗ § 23.2).
    token: {
      none: 'Жетон не списывался.',
      refunded: 'Жетон за это нажатие вернулся.',
      refundedCount_one: 'За это нажатие вернулся {{count}} жетон.',
      refundedCount_few: 'За это нажатие вернулось {{count}} жетона.',
      refundedCount_many: 'За это нажатие вернулось {{count}} жетонов.',
      spent_one: 'Жетон ушёл на то, что готово.',
      spent_few: 'Жетоны ушли на то, что готово.',
      spent_many: 'Жетоны ушли на то, что готово.',
      checked_one: 'Жетон ушёл на проверку слова.',
      checked_few: 'Жетоны ушли на проверку слов.',
      checked_many: 'Жетоны ушли на проверку слов.',
    },
    manualNote: 'Создана вручную — без примера, смысла и подсказки.',
    item: {
      generating: 'генерируется',
      slow: 'дольше обычного',
      extending: 'дописываем часть речи',
      notAdded: 'не добавилось',
      failed: 'не получилось',
      failedReason: 'ИИ не ответил вовремя — попробуй ещё раз.',
      restricted: 'ИИ не обрабатывает это слово: в словаре у него есть значения 18+. Добавь карточку вручную.',
      typo: 'похоже на опечатку',
      suggest: 'Может, {{word}}?',
      garbage: 'не распознано',
      removed: 'удалена',
    },
    skip: {
      already_added: 'уже есть в модуле',
      not_in_dictionary: 'нет в словаре',
      not_in_topic: 'не по теме подборки',
      quota: 'не хватило жетонов',
      in_progress: 'ещё генерируется',
      error: 'не получилось',
      other: 'не создана',
    },
    action: {
      retryPaid: 'Повторить · 1 жетон',
      retryShort: 'Повторить · 1',
      retrying: 'Запускаем…',
      noCredits: 'Жетоны закончились',
      manual: 'Добавить вручную',
      fix: 'Разобрать',
      // Опечатка с подсказкой: исправленное слово — в строку создания (страницы «Из словаря» больше нет, 2026-10-21).
      enterWord: 'Ввести «{{word}}»',
      reenter: 'Ввести снова',
      openModule: 'Открыть модуль →',
      // Без числа (владелец 2026-10-28): число карточек этого нажатия не совпадало с тем, что в тренировке.
      train: 'Тренировать новые',
      collapse: 'Свернуть',
      // Свернуть порцию — не «Свернуть»: так называется кнопка всей записи (A2-06). fewerItems — к «ещё N» у фраз.
      fewer: 'Скрыть',
      fewerItems: 'скрыть',
      moreSenses_one: 'Показать ещё {{count}} перевод',
      moreSenses_few: 'Показать ещё {{count}} перевода',
      moreSenses_many: 'Показать ещё {{count}} переводов',
    },
    errors: {
      retryFailed: 'Не удалось запустить. Попробуй ещё раз.',
      cardGone: 'Карточки больше нет в модуле.',
    },
  },
  shared: {
    passwordInput: {
      show: 'Показать пароль',
      hide: 'Скрыть пароль',
    },
  },
  network: {
    serverDown: {
      title: 'Сервер не отвечает',
      sub: 'Похоже, проблемы со связью или сервер временно недоступен. Мы продолжаем попытки подключиться.',
    },
    offline: {
      title: 'Нет подключения к интернету',
      sub: 'Проверь Wi-Fi или мобильную сеть. Как только сеть появится — мы автоматически восстановим работу.',
    },
    reconnected: {
      title: 'Связь восстановлена',
      sub: 'Обновляем данные…',
    },
    retry: 'Повторить',
    retrying: 'Подключаемся…',
  },
  emailVerify: {
    full: {
      resend: 'Отправить ещё раз',
      resendDone: '✓ Отправлено',
      resendCooldown: 'Повтор через {{n}}\u00a0с',
      resending: 'Отправляем…',
      resendError: 'Ошибка — ещё раз',
      preview: 'открыть письмо (превью) →',
    },
    compact: {
      // «Почта», а не «email»: строкой ниже — «Подтверди почту» (правила текста ТЗ демо, R2-11).
      titlePrefix: 'Почта',
      titleSuffix: 'ещё не подтверждена',
      body: 'Подтверди почту — откроем свои слова.',
      resend: 'Отправить ещё раз',
      resendDone: '✓ Отправлено',
      resendCooldown: 'Повтор через {{n}}\u00a0с',
      resending: 'Отправляем…',
      resendError: 'Ошибка — ещё раз',
    },
    // Итог знакомства (EmailConfirmNote) и заблокированная строка создания на главной; подписи кнопки — из full.
    nudge: {
      title: 'Подтверди почту\u00a0— и\u00a0создавай карточки дальше',
      bodyPrefix: 'Ссылка — в письме на',
    },
  },
  auth: {
    signIn: {
      title: 'С возвращением',
      sub: 'Войди, чтобы продолжить обучение.',
      submit: 'Войти',
      noAccount: 'Нет аккаунта?',
      switchToSignUp: 'Создать',
    },
    signUp: {
      title: 'Создать аккаунт',
      sub: 'Собери свои слова и тренируйся в удобном темпе.',
      // Пришёл за игрой (демо, ролик): после регистрации сразу миссия дня.
      subGame: 'Сразу после регистрации\u00a0— в игру. Каждый день новая миссия в Лондоне.',
      submit: 'Создать аккаунт',
      hasAccount: 'Уже есть аккаунт?',
      switchToSignIn: 'Войти',
    },
    fields: {
      name: 'Имя',
      email: 'Email',
      password: 'Пароль',
      confirmPassword: 'Подтверждение пароля',
      namePlaceholder: 'Алекс',
      emailPlaceholder: 'you@example.com',
      passwordPlaceholder: '••••••••',
      confirmPasswordPlaceholder: 'повтори пароль',
    },
    social: {
      orEmail: 'или email',
      yandex: 'Яндекс',
    },
    promo: {
      kicker: 'Самостоятельная практика английского',
      quotePart1: 'Нужные слова',
      quotePart1Em: 'под рукой',
      quotePart2: 'Тренировка',
      quotePart2Em: 'по твоим правилам',
      footer: 'Модули · карточки · упражнения',
    },
    errors: {
      invalidCredentials: 'Неверный email или пароль',
      requiredFields: 'Заполни все поля',
      shortPassword: 'Минимум 8 символов',
      invalidEmail: 'Email некорректный',
      nameRequired: 'Введи имя',
      emailRequired: 'Введи email',
      passwordRequired: 'Введи пароль',
      confirmRequired: 'Подтверди пароль',
      passwordMismatch: 'Пароли не совпадают',
      emailExists: 'Аккаунт с такой почтой уже есть',
      network: 'Не удалось связаться с сервером',
      // Регистрация, 2026-10-27: раньше любой отказ сервера был «Email некорректный», 429 и 500 — «Аккаунт уже есть».
      invalidName: 'Имя — не длиннее 50 символов',
      invalidData: 'Проверь поля и попробуй ещё раз',
      rateLimited: 'Слишком много попыток — подожди минуту',
      server: 'Не получилось — попробуй ещё раз',
      offerRequired: 'Отметь согласие с офертой',
    },
    version: 'v2.4 · 2026',
    versionSecure: 'v2.4 · 2026 · защищённый запрос',
    forgotLink: 'Забыли пароль?',
    forgot: {
      stepTags: {
        a: '01 · email',
        b: '02 · письмо',
        c: '03 · пароль',
      },
      backToSignIn: 'ко входу',
      title: 'Забыли пароль?',
      leadHead: 'Бывает. Введи email — пришлём письмо со ссылкой, по которой',
      leadStrong: 'зададишь новый пароль',
      leadTail: '.',
      emailLabel: 'Email от аккаунта',
      submit: 'Отправить ссылку',
      info: 'Если такого аккаунта нет — мы всё равно покажем «отправлено». Это защищает наших учеников от перебора почт.',
      rememberPrefix: 'Вспомнили пароль?',
      rememberLink: 'Войти',
      sent: {
        title: 'Письмо',
        titleEm: 'в пути',
        subPrefix: 'Открой почту и нажми «Сбросить пароль». Если не видишь письма за минуту — проверь «Промоакции» и «Спам». Отправили на',
        next: 'Перейти к смене пароля',
        back: 'Вернуться ко входу',
        resendPrompt: 'Не пришло?',
        resend: 'отправить ещё раз',
        resendIn: 'через {{time}}',
        resendReady: 'готово',
      },
      errors: {
        invalidEmail: 'Похоже, это не email — проверь адрес.',
      },
      promo: {
        eyebrow: 'Сброс пароля · 3 шага',
        quotePart1: 'Никаких',
        quotePart1Em: 'лишних',
        quotePart1Tail: 'вопросов.',
        quotePart2: 'Только новый',
        quotePart2Em: 'пароль',
        quotePart2Tail: '.',
        steps: [
          { num: '01', head: 'Email', desc: 'Скажи, на какой адрес отправить ссылку.' },
          { num: '02', head: 'Письмо', desc: 'Кнопка в письме откроет страницу смены пароля. Ссылка живёт 15 минут.' },
          { num: '03', head: 'Новый пароль', desc: 'Двойной ввод, проверка надёжности — и обратно к карточкам.' },
        ],
        foot: 'security@lomora.ru',
      },
    },
    confirmEmail: {
      kicker: 'Подтверждение почты',
      pending: {
        title: 'Подтверждаем почту…',
        sub: 'Секунду — проверяем ссылку.',
      },
      success: {
        title: 'Почта',
        titleEm: 'подтверждена',
        sub: 'Готово — теперь можно добавлять свои слова.',
        redirectPrefix: 'Возвращаем тебя на',
        targetApp: 'главную',
        targetSignIn: 'экран входа',
        redirectSuffix: '…',
        goApp: 'На главную',
        goSignIn: 'Перейти ко входу',
      },
      // Ссылка устарела (истекла, использована или неверна), а почта у вошедшего уже подтверждена (B6).
      already: {
        title: 'Почта уже подтверждена',
        sub: 'Всё в порядке — свои слова уже открыты.',
      },
      error: {
        title: 'Ссылка не сработала',
        expiredTitle: 'Ссылка устарела',
        // Дальше — адрес (EmailText), поэтому строка разбита.
        expiredAppPrefix: 'Ссылка действует 24 часа и срабатывает один раз. Новое письмо придёт на',
        expiredGuest:
          'Ссылка действует 24 часа и срабатывает один раз. Если почта уже подтверждена — просто войди. Если нет — войди и нажми «Отправить ещё раз»: пришлём новую ссылку.',
        resend: 'Отправить новое письмо',
        sentPrefix: 'Отправили новое письмо на',
        sentSuffix: '. Открой его и нажми «Подтвердить почту».',
        missing: 'Ссылка открылась не целиком. Открой письмо ещё раз и нажми «Подтвердить почту».',
        network: 'Нет связи с сервером. Проверь интернет и попробуй ещё раз.',
        rateLimit: 'Слишком много попыток подряд. Подожди минуту и попробуй снова.',
        generic: 'Что-то пошло не так на нашей стороне. Попробуй ещё раз через минуту.',
        retry: 'Повторить',
        signIn: 'Войти',
        back: 'Вернуться ко входу',
      },
    },
    oauth: {
      kicker: 'Вход через провайдера',
      pending: {
        title: 'Завершаем вход…',
        sub: 'Секунду — настраиваем твою сессию.',
      },
      success: {
        title: 'Добро',
        titleEm: 'пожаловать',
        sub: 'Сессия создана. Сейчас откроем главную и можно учить слова.',
        redirectPrefix: 'Возвращаем тебя на',
        redirectStrong: 'главную',
        redirectSuffix: '…',
        goApp: 'На главную',
      },
      error: {
        title: 'Не удалось войти',
        OAUTH_PROVIDER_ERROR: 'Провайдер вернул ошибку и прервал вход. Попробуй ещё раз.',
        OAUTH_MISSING_PARAMS: 'В ссылке потерялись параметры. Запусти вход заново.',
        INVALID_OAUTH_STATE: 'Ссылка устарела или открыта в другом браузере. Запусти вход заново.',
        OAUTH_PROVIDER_MISMATCH: 'Провайдер не совпал с тем, через который ты начинал вход. Попробуй ещё раз.',
        OAUTH_LOGIN_FAILED: 'Не получилось завершить вход. Попробуй ещё раз через минуту.',
        OAUTH_REFRESH_FAILED: 'Не получили токен сессии. Войди ещё раз.',
        generic: 'Что-то пошло не так. Попробуй ещё раз.',
        back: 'Вернуться ко входу',
      },
    },
    reset: {
      stepTags: {
        a: '01 email',
        b: '02 письмо',
        c: '03 · пароль',
      },
      ttlPrefix: 'ссылка живёт',
      ttlExpired: 'истекла',
      title: 'Новый пароль',
      lead: 'Придумай пароль, который не потеряешь. Минимум — 8 символов; рекомендуем длинную фразу.',
      pw1Label: 'Новый пароль',
      pw1Hint: 'не короче 8 символов',
      pw2Label: 'Повтори новый пароль',
      submit: 'Сохранить новый пароль',
      backPrefix: 'Передумал?',
      backLink: 'Назад ко входу',
      chars: '{{n}} симв.',
      strength: {
        idle: 'введи пароль — покажем надёжность',
        label: 'надёжность',
        levels: ['слабый', 'базовый', 'хороший', 'надёжный', 'крепкий'],
      },
      rules: {
        len: 'от 8 символов',
        mix: 'буквы разного регистра',
        num: 'хотя бы одна цифра',
        sym: 'спец-символ или 12+ симв.',
      },
      match: {
        empty: 'введи пароль ещё раз для проверки',
        ok: '✓ пароли совпадают',
        bad: '× пароли не совпадают',
      },
      errors: {
        missingToken: 'В ссылке нет токена. Запроси новую через «Забыли пароль?».',
        expired: 'Ссылка истекла или уже использовалась. Запроси новую.',
        generic: 'Не удалось обновить пароль. Попробуй ещё раз.',
      },
      verify: {
        checking: 'Проверяем ссылку…',
        invalid: {
          title: 'Ссылка не сработала',
          body: 'Ссылка для сброса пароля недействительна или истекла. Запроси новую — она живёт 15 минут.',
          cta: 'Запросить новую ссылку',
        },
      },
      done: {
        title: 'Готово, пароль',
        titleEm: 'обновлён',
        sub: 'Все остальные сессии вышли автоматически. Войди заново с новым паролем — и продолжай учить слова.',
        redirectPrefix: 'Возвращаем тебя на',
        redirectStrong: 'экран входа',
        redirectSuffix: '…',
        loginNow: 'Войти сейчас',
      },
      promo: {
        eyebrow: 'Финальный шаг · 03 / 03',
        quotePart1: 'Один пароль —',
        quotePart2: 'и снова',
        quotePart2Em: 'в карточки',
        quotePart2Tail: '.',
        cardTitle: 'Что произойдёт после сохранения',
        cardItems: [
          { num: '01', head: 'Все устройства выйдут.', body: 'На телефоне и других браузерах попросят войти заново.' },
          { num: '02', head: 'Прогресс не пострадает.', body: 'Карточки, повторения, статистика — всё на месте.' },
          { num: '03', head: 'Ссылка сгорит.', body: 'Второй раз по ней пароль не сменить — если понадобится, запросишь новую.' },
        ],
        foot: 'security@lomora.ru',
      },
    },
  },
  onboarding: {
    skip: 'Пропустить',
    errorRetry: 'Не удалось сохранить. Попробуй ещё раз.',
    appLoader: 'Загружаем профиль…',
    // Знакомство (2026-10-19): экран модуля → тренировка на 5 слов → итог.
    intro: {
      title: 'Lomora — тренажёр английских слов',
      pointDictionary: 'Перевод и транскрипция — из словаря',
      pointTopics: 'Готовые темы и свои слова',
      pointQuick: 'Тренировка — за 2 минуты',
      moduleLabel: 'Твой первый модуль',
      pickLabel: 'Выбери тему',
      otherTopic: 'другая тема',
      collapse: 'свернуть',
      words_one: '{{count}} слово',
      words_few: '{{count}} слова',
      words_many: '{{count}} слов',
      starterError: 'Не удалось загрузить тему.',
      starterRetry: 'Повторить',
      start: 'Начать: 5 слов за 2 минуты',
      starting: 'Готовим тренировку…',
      skipping: 'Сохраняем…',
      startError: 'Тренировка не запустилась. Попробуй ещё раз или пропусти.',
      networkError: 'Нет связи с сервером. Проверь интернет и попробуй ещё раз.',
      rateLimit: 'Слишком много попыток. Подожди минуту и попробуй снова.',
      // «С чего начнём?» — миссия дня или 5 слов (решение владельца 2026-10-30).
      choiceTitle: 'С чего начнём?',
      missionLabel: 'Игра',
      missionTitle: 'Миссия дня в Лондоне',
      missionText: 'Поговори с жителем Лондона по-английски\u00a0— голосом или текстом. 3–5 минут, ответы разбирает ИИ.',
      missionStart: 'Играть',
      missionStarting: 'Открываем миссию…',
      lookAround: 'Сначала осмотреться',
      // «Свои слова» — карточка на своё слово (решение владельца 2026-11-02); без почты — одна бесплатно.
      cardLabel: 'Свои слова',
      cardTitle: 'Карточка на\u00a0твоё слово',
      cardText: 'Впиши слово из книги, сериала или с\u00a0работы. Перевод и\u00a0транскрипция\u00a0— из\u00a0словаря, пример и\u00a0смысл добавит ИИ.',
      cardStart: 'Создать карточку',
      cardStarting: 'Открываем…',
      // Свой модуль, куда ляжет первая карточка.
      cardModule: 'Мои слова',
    },
    // Первая карточка тренировки знакомства — до первого ответа.
    training: {
      noteMcq: 'Не знаешь слово — выбирай по смыслу предложения. После ответа покажем перевод.',
      noteInput: 'Переведи только выделенное слово, не всё предложение. Не знаешь его — нажми «не помню»: покажем перевод и пример.',
    },
    result: {
      score: '{{correct}} из {{total}}',
      scorePerfect: '{{correct}} из {{total}}!',
      firstTry: 'верно с первого раза',
      // Меньше 60% с первой попытки — без счёта (isLowResult).
      newWords_one: '{{count}} новое слово в твоём модуле',
      newWords_few: '{{count}} новых слова в твоём модуле',
      newWords_many: '{{count}} новых слов в твоём модуле',
      newWords_other: '{{count}} новых слова в твоём модуле',
      firstTryCount: '{{count}} — с первого раза',
      zeroFirstTry: 'Слова вернутся в следующих тренировках — так они и запоминаются.',
      streak: '1-й день серии',
      noScoreTitle: 'Модуль уже на главной',
      noScoreSub: 'Тренировку можно продолжить в любой момент.',
      remindTitle: 'Когда напоминать?',
      remindVia: 'Письмом на почту',
      remindMsk: 'время московское',
      remindOff: 'не надо',
      toDashboard: 'На главную',
      saving: 'Сохраняем…',
    },
    // Карточки ниже читает только SessionGuide (на главной не подключён).
    steps: {
      session: {
        cards: {
          c1: {
            h: 'Выбери модуль',
            t: 'Нажми «Начать тренировку» на главной и выбери модуль со словами. Тренировку также можно открыть прямо из модуля.',
          },
          c2: {
            h: 'Собери тренировку',
            t: 'Выбери упражнения. Оставь все карточки модуля или отметь только нужные.',
          },
          c3: {
            h: 'Практикуйся',
            t: 'Отвечай на задания в своём темпе. Если ошибёшься, увидишь правильный ответ и сможешь продолжить.',
          },
          c4: {
            h: 'Финал и итоги',
            t: 'В конце собери слова в пары и посмотри результаты. Если нужно остановиться раньше, нажми «Завершить досрочно».',
          },
        },
      },
    },
  },
  trainingGuide: {
    title: 'Как проходит тренировка',
    sub: 'модуль, упражнения и финал',
    close: 'Понятно',
  },
  nav: {
    dashboard: 'Главная',
    words: 'Слова и модули',
    grammar: 'Грамматика',
    // Вкладки телефона (решение владельца 2026-10-23): Главная · Слова и модули · Игра · Ещё.
    game: 'Игра',
    more: 'Ещё',
    notifications: 'Уведомления',
    profile: 'Настройки',
    plans: 'Тарифы',
    community: 'Сообщество',
    useful: 'Полезное',
    stories: 'Выживи в Лондоне',
    newBadge: 'новое',
    admin: 'Админ',
    installApp: 'Установить на телефон',
    aria: {
      expand: 'Развернуть сайдбар',
      collapse: 'Свернуть сайдбар',
      home: 'Lomora — на главную',
      tabs: 'Разделы',
      moreUnread_one: 'Ещё: {{count}} новое уведомление',
      moreUnread_few: 'Ещё: {{count}} новых уведомления',
      moreUnread_many: 'Ещё: {{count}} новых уведомлений',
      moreUnread_other: 'Ещё: {{count}} новых уведомления',
      // Меню второстепенного и колокольчик уведомлений (решение владельца 2026-10-21).
      profileMenu: 'Меню профиля',
      notificationsCount_one: 'Уведомления, {{count}} новое',
      notificationsCount_few: 'Уведомления, {{count}} новых',
      notificationsCount_many: 'Уведомления, {{count}} новых',
      notificationsCount_other: 'Уведомления, {{count}} новых',
    },
  },
  useful: {
    title: 'Полезное',
    sub: 'Неправильные и фразовые глаголы, звуки английского и алфавит: таблицы с транскрипцией, озвучка и тренажёры.',
    tabs: {
      verbs: 'Неправильные глаголы',
      phrasal: 'Фразовые глаголы',
      sounds: 'Звуки английского',
      alphabet: 'Английский алфавит',
    },
  },
  // «Грамматика» (2026-10-23): «Тропинка» тем, урок, упражнения. Для детей — коротко и по-доброму; слово ИИ-проверки — «разбор».
  grammar: {
    intro: 'Правила по шагам: прочитай — и сразу потренируйся. За каждое упражнение — звёзды.',
    levels: 'Уровень',
    pathLabel: 'Темы уровня {{level}}',
    continue: 'Продолжить',
    startHere: 'Начни отсюда',
    next: 'Дальше',
    youAreHere: 'ты здесь',
    mastered: 'освоена',
    passed: 'пройдена',
    reviewDue: 'пора повторить',
    // Легенда над тропинкой (2026-10-26): ключ к кружкам «пройдена» и «освоена».
    legend: {
      passed: 'пройдена\u00a0— сделано упражнение\u00a01',
      mastered_one: 'освоена\u00a0— «{{level}}» и повтор без\u00a0ошибок через\u00a0{{count}} день',
      mastered_few: 'освоена\u00a0— «{{level}}» и повтор без\u00a0ошибок через\u00a0{{count}} дня',
      mastered_many: 'освоена\u00a0— «{{level}}» и повтор без\u00a0ошибок через\u00a0{{count}} дней',
      mastered_other: 'освоена\u00a0— «{{level}}» и повтор без\u00a0ошибок через\u00a0{{count}} дня',
    },
    recommended: 'Тебе стоит пройти',
    draft: 'Черновик',
    empty: 'На этом уровне тем пока нет.',
    loadError: 'Не получилось загрузить грамматику.',
    retry: 'Повторить',
    blank: 'пропуск',
    starsLabel: 'Упражнений пройдено: {{done}} из {{total}}',
    lesson: {
      back: 'Грамматика',
      requires: 'Сначала повтори',
      contrasts: 'Не путай с',
      seeAlso: 'Ещё по теме',
      mistakes: 'Частые ошибки',
      exercises: 'Упражнения',
      core: 'Главное',
      step: 'Шаг {{n}}',
      stepOf: 'Шаг {{n}} из {{total}}',
      stepsNav: 'Шаги урока',
      goToStep: 'Шаг {{n}}: {{title}}',
      prev: 'Назад',
      next: 'Дальше',
      nextTo: 'Дальше: {{title}}',
      toExercises: 'К упражнениям',
      check: 'Проверь себя',
      mistake: 'Частая ошибка',
      sheet: 'Шпаргалка',
      sheetHint: 'Собирается по шагам',
      sheetLocked: 'Откроется на шаге {{n}}',
      aside: 'Шпаргалка и упражнения',
      compareRu: 'По-русски',
      compareEn: 'По-английски',
      gap: 'здесь по-русски ничего не говорят',
      notWritten: 'Урок ещё пишется — его видит только админ.',
      notFound: 'Такой темы нет или она ещё не готова.',
      passRule: 'Тема засчитывается после упражнения\u00a01.',
      readTitle: 'Урок прочитан',
      readNext: 'Теперь упражнение\u00a01\u00a0— после него тема пройдена.',
      passedTitle: 'Тема пройдена',
      masterNext_one: 'Чтобы освоить\u00a0— «{{level}}» и повтор без\u00a0ошибок через\u00a0{{count}} день.',
      masterNext_few: 'Чтобы освоить\u00a0— «{{level}}» и повтор без\u00a0ошибок через\u00a0{{count}} дня.',
      masterNext_many: 'Чтобы освоить\u00a0— «{{level}}» и повтор без\u00a0ошибок через\u00a0{{count}} дней.',
      masterNext_other: 'Чтобы освоить\u00a0— «{{level}}» и повтор без\u00a0ошибок через\u00a0{{count}} дня.',
      masteredTitle: 'Тема освоена',
    },
    exercise: {
      verify: 'Платные упражнения\u00a0— после подтверждения почты: открой ссылку из письма.',
      title: 'Упражнение {{n}}',
      hint: 'От лёгкого к сложному: первое — бесплатно, в сложных — ловушки, на которых учатся больше всего.',
      items_one: '{{count}} задание',
      items_few: '{{count}} задания',
      items_many: '{{count}} заданий',
      items_other: '{{count}} задания',
      free: 'Бесплатно',
      start: 'Начать',
      continue: 'Продолжить',
      again: 'Ещё раз',
      opening: 'Открываем…',
      openFor_one: 'Открыть · {{count}} жетон',
      openFor_few: 'Открыть · {{count}} жетона',
      openFor_many: 'Открыть · {{count}} жетонов',
      openFor_other: 'Открыть · {{count}} жетона',
      goTo: 'К упражнению {{n}}',
      openNo_one: 'Открыть упражнение {{n}} · {{count}} жетон',
      openNo_few: 'Открыть упражнение {{n}} · {{count}} жетона',
      openNo_many: 'Открыть упражнение {{n}} · {{count}} жетонов',
      openNo_other: 'Открыть упражнение {{n}} · {{count}} жетона',
      noTokens: 'Не хватает жетонов',
      openError: 'Не получилось открыть упражнение. Попробуй ещё раз.',
      levelLabel: 'Сложность',
      levels: {
        easy: 'Лёгкое',
        medium: 'Среднее',
        hard: 'Сложное',
        master: 'Мастер',
      },
    },
    openConfirm: {
      kicker: 'Открыть упражнение',
      text_one: 'Спишется {{count}} жетон. Упражнение откроется один раз и останется твоим — проходи его сколько угодно.',
      text_few: 'Спишется {{count}} жетона. Упражнение откроется один раз и останется твоим — проходи его сколько угодно.',
      text_many: 'Спишется {{count}} жетонов. Упражнение откроется один раз и останется твоим — проходи его сколько угодно.',
      text_other: 'Спишется {{count}} жетона. Упражнение откроется один раз и останется твоим — проходи его сколько угодно.',
      balance_one: 'На балансе: {{count}} жетон',
      balance_few: 'На балансе: {{count}} жетона',
      balance_many: 'На балансе: {{count}} жетонов',
      balance_other: 'На балансе: {{count}} жетона',
      cancel: 'Отмена',
    },
    play: {
      verifyTitle: 'Разбор ИИ\u00a0— после подтверждения почты',
      verifyText: 'Открой ссылку из письма\u00a0— и ИИ разберёт свободные ответы. Задания с выбором проверяются уже сейчас.',
      verifyTextTo: 'Открой ссылку из письма на {{email}}\u00a0— и ИИ разберёт свободные ответы. Задания с выбором проверяются уже сейчас.',
      exit: 'Выйти к уроку',
      progress: 'Задание {{n}} из {{total}}',
      analysesLeft_one: 'Остался {{count}} разбор',
      analysesLeft_few: 'Осталось {{count}} разбора',
      analysesLeft_many: 'Осталось {{count}} разборов',
      analysesLeft_other: 'Осталось {{count}} разбора',
      analysesHint: 'Разбор — ИИ проверит твой ответ и объяснит ошибку',
      types: {
        choice: 'Выбери верный вариант',
        fill: 'Впиши пропущенное',
        fillFree: 'Напиши ответ по-английски',
        fix: 'Исправь ошибку',
        translate: 'Переведи на английский',
        write: 'Напиши своё предложение',
      },
      example: 'Например:',
      showExample: 'Показать пример',
      placeholder: 'Твой ответ по-английски',
      check: 'Проверить',
      checking: 'Проверяем…',
      correct: 'Верно! 🎉',
      almost: 'Почти! 👍',
      wrong: 'Не совсем 🙂',
      rightAnswer: 'Правильно:',
      review: 'Разбор',
      reviewFree: 'бесплатный',
      reviewPaid: 'из купленных',
      next: 'Дальше',
      finish: 'Готово',
      noAnalysesTitle: 'Бесплатные разборы закончились',
      noAnalysesText_one: 'Ещё {{dose}} разбор — и ИИ проверит ответ и объяснит ошибки.',
      noAnalysesText_few: 'Ещё {{dose}} разбора — и ИИ проверит ответ и объяснит ошибки.',
      noAnalysesText_many: 'Ещё {{dose}} разборов — и ИИ проверит ответ и объяснит ошибки.',
      noAnalysesText_other: 'Ещё {{dose}} разбора — и ИИ проверит ответ и объяснит ошибки.',
      buyDose_one: 'Ещё {{dose}} разбора · {{count}} жетон',
      buyDose_few: 'Ещё {{dose}} разбора · {{count}} жетона',
      buyDose_many: 'Ещё {{dose}} разбора · {{count}} жетонов',
      buyDose_other: 'Ещё {{dose}} разбора · {{count}} жетона',
      skip: 'Пропустить',
      noTokensText: 'Новые жетоны придут завтра, а ещё их можно взять в тарифах.',
      plans: 'Тарифы',
      unavailable: 'ИИ не ответил — разбор не списан. Попробуй ещё раз.',
      notEnglish: 'Напиши ответ по-английски.',
      error: 'Не получилось проверить. Попробуй ещё раз.',
      tryAgain: 'Ещё раз',
      notFound: 'Такого упражнения нет.',
      lockedTitle: 'Упражнение {{n}} закрыто',
      lockedText_one: 'Открой его за {{count}} жетон — один раз, и оно останется твоим.',
      lockedText_few: 'Открой его за {{count}} жетона — один раз, и оно останется твоим.',
      lockedText_many: 'Открой его за {{count}} жетонов — один раз, и оно останется твоим.',
      lockedText_other: 'Открой его за {{count}} жетона — один раз, и оно останется твоим.',
      finishTitle: 'Упражнение пройдено!',
      finishText: 'Верно: {{solved}} из\u00a0{{total}}',
      starsLabel_one: '{{count}} звезда из 3',
      starsLabel_few: '{{count}} звезды из 3',
      starsLabel_many: '{{count}} звёзд из 3',
      starsLabel_other: '{{count}} звезды из 3',
      nextExercise: 'Дальше: упражнение {{n}}',
      toLesson: 'К уроку',
      again: 'Пройти ещё раз',
      passedTitle: 'Тема пройдена!',
      nextTopic: 'Следующая тема',
      openShort_one: 'Упражнение\u00a0{{n}} · {{count}} жетон',
      openShort_few: 'Упражнение\u00a0{{n}} · {{count}} жетона',
      openShort_many: 'Упражнение\u00a0{{n}} · {{count}} жетонов',
      openShort_other: 'Упражнение\u00a0{{n}} · {{count}} жетона',
      fixTitle: 'Почти готово!',
      fixText_one: 'Осталось исправить {{count}} задание — ответь на него ещё раз, пока всё не станет зелёным.',
      fixText_few: 'Осталось исправить {{count}} задания — ответь на них ещё раз, пока всё не станет зелёным.',
      fixText_many: 'Осталось исправить {{count}} заданий — ответь на них ещё раз, пока всё не станет зелёным.',
      fixText_other: 'Осталось исправить {{count}} задания — ответь на них ещё раз, пока всё не станет зелёным.',
      fixStart: 'Исправить ошибки',
      fixChip: 'Работа над ошибками',
      backTo: 'К заданию {{n}}',
      retry: 'Ответить ещё раз',
      yourAnswer: 'Твой ответ:',
      itemLabel: 'Задание {{n}}: {{state}}',
      before: 'Раньше: {{state}}',
      tone: {
        right: 'верно',
        wrong: 'с ошибкой',
        none: 'без ответа',
      },
    },
    // Подборка повторения (владелец 2026-10-25): темы забываются, как слова, — повторяем пройденные.
    review: {
      kicker: 'Повторение',
      title: 'Повтори пройденное',
      why: 'Пройденные темы забываются так же, как слова. Поэтому мы следим, что ты учишь, и собираем подборку тем, пройденных день или несколько дней назад, — чтобы повторить их, пока не забылись.',
      reasonDue: 'пора повторить',
      reasonMistakes_one: '{{count}} ошибка',
      reasonMistakes_few: '{{count}} ошибки',
      reasonMistakes_many: '{{count}} ошибок',
      reasonMistakes_other: '{{count}} ошибки',
      meta_one: '{{count}} задание · около трёх минут',
      meta_few: '{{count}} задания · около трёх минут',
      meta_many: '{{count}} заданий · около трёх минут',
      meta_other: '{{count}} задания · около трёх минут',
      reward_one: '+{{count}} жетон',
      reward_few: '+{{count}} жетона',
      reward_many: '+{{count}} жетонов',
      reward_other: '+{{count}} жетона',
      start: 'Начать',
      later: 'Позже',
      finish: 'Завершить',
      doneTitle: 'Подборка пройдена!',
      score: 'Верно {{right}} из {{total}}',
      doneClean: 'Без ошибок — следующий повтор этих тем будет позже.',
      doneMistakes: 'Темы с ошибками вернутся в подборку завтра — так они закрепятся.',
      nextDue: 'Следующая подборка — {{date}}',
      emptyTitle: 'Сегодня повторять нечего',
      emptyText: 'Подборка появится, когда будут пройденные темы: первый повтор — через день после урока.',
      toGrammar: 'К грамматике',
      toHome: 'На главную',
      loadFailed: 'Не получилось загрузить подборку. Проверь соединение и попробуй ещё раз.',
      failed: 'Ответ не дошёл. Попробуй ещё раз.',
      stale: 'Подборка обновилась — начался новый день. Открой её заново.',
      rowKicker: 'Повтори грамматику',
      rowAction: 'Повторить',
      rowDone: 'Подборка на сегодня пройдена',
    },
    title: 'Грамматика',
    // Награды за темы (решение владельца 2026-10-23): каждые N пройденных — несгораемые жетоны, сложная тема — ещё жетон.
    rewards: {
      progress_one: 'Ещё {{count}} тема до награды: +{{tokens}}',
      progress_few: 'Ещё {{count}} темы до награды: +{{tokens}}',
      progress_many: 'Ещё {{count}} тем до награды: +{{tokens}}',
      progress_other: 'Ещё {{count}} темы до награды: +{{tokens}}',
      rule_one: '+{{count}} несгораемый жетон за каждые {{step}} пройденных тем',
      rule_few: '+{{count}} несгораемых жетона за каждые {{step}} пройденных тем',
      rule_many: '+{{count}} несгораемых жетонов за каждые {{step}} пройденных тем',
      rule_other: '+{{count}} несгораемых жетона за каждые {{step}} пройденных тем',
      hardTitle_one: 'Сложная тема: за прохождение +{{count}} жетон',
      hardTitle_few: 'Сложная тема: за прохождение +{{count}} жетона',
      hardTitle_many: 'Сложная тема: за прохождение +{{count}} жетонов',
      hardTitle_other: 'Сложная тема: за прохождение +{{count}} жетона',
      hardBadge: 'Сложная тема — за прохождение жетон',
      forTopics_one: 'за {{count}} пройденную тему',
      forTopics_few: 'за {{count}} пройденные темы',
      forTopics_many: 'за {{count}} пройденных тем',
      forTopics_other: 'за {{count}} пройденной темы',
      forHard: 'за сложную тему',
      title: 'Проходи темы — получай жетоны',
      hardRule_one: 'за сложную тему — ещё +{{count}}',
      hardRule_few: 'за сложную тему — ещё +{{count}}',
      hardRule_many: 'за сложную тему — ещё +{{count}}',
      hardRule_other: 'за сложную тему — ещё +{{count}}',
      howTo: 'Тема засчитывается, когда пройдено её первое упражнение.',
    },
  },
  community: {
    title: 'Сообщество',
    sub: 'Заглядывай: разборы слов, новости Lomora и живое общение.',
    openAction: 'Открыть',
    telegram: {
      name: 'Telegram',
      desc: 'Новости, апдейты и короткие заметки о словах.',
    },
    vk: {
      name: 'ВКонтакте',
      desc: 'Наше сообщество ВКонтакте — посты и обсуждения.',
    },
    dzen: {
      name: 'Дзен',
      desc: 'Большие статьи и разборы — как практиковать английский и запоминать слова.',
    },
  },
  cardsWorkspace: {
    // Два способа создать карточки — вкладки над рабочей областью (CreationTabs, 2026-10-16).
    tabs: {
      label: 'Как создать карточки',
      dictionary: 'Слово из словаря',
      dictionaryHint: 'Найди слово и выбери переводы',
      dictionaryShort: 'Из словаря',
      topic: 'Подбор слов по теме',
      topicHint: 'ИИ подберёт 10–20 слов по твоей теме',
      topicShort: 'Подбор по теме',
    },
    header: {
      eyebrow: 'Карточки',
      inModule: 'в модуль {{title}}',
      titleAi: 'Создание карточек',
      newCards: 'Новые карточки',
      in: 'в',
    },
    locked: {
      title: 'Подтверди почту, чтобы создавать карточки',
    },
    nav: {
      dashboard: 'Дашборд',
    },
    emptyModule: {
      title: 'Выбери модуль, чтобы увидеть очередь',
      body: 'Очередь карточек строится по конкретному модулю. Кликни по чипу модуля сверху — или создай новый прямо там.',
    },
    loadingQueue: 'Загружаем очередь карточек',
    appbar: {
      list: 'Карточки',
      limitations: 'Ограничения',
      composer: 'Новая карточка',
      ready: 'Карточка готова',
      garbage: 'Не распознано',
      problem: 'Не получилось',
    },
    aria: {
      back: 'Назад',
      close: 'Закрыть',
    },
    status: {
      manual: 'ручной ввод',
      generating: 'генерация…',
      queued: 'в очереди',
      ready: 'готова',
      typo: 'опечатка?',
      garbage: 'не распознано',
      error: 'ошибка',
    },
    filters: {
      all: 'Все',
      manual: 'Ручные',
      ai: 'С помощью ИИ',
      generating: 'Генерируются',
    },
    sections: {
      action_one: 'Ждут тебя · {{count}}',
      action_few: 'Ждут тебя · {{count}}',
      action_many: 'Ждут тебя · {{count}}',
      inflight_one: 'В работе · {{count}}',
      inflight_few: 'В работе · {{count}}',
      inflight_many: 'В работе · {{count}}',
      ready_one: 'Готовые · {{count}}',
      ready_few: 'Готовые · {{count}}',
      ready_many: 'Готовые · {{count}}',
    },
    pos: {
      noun: 'существительное',
      verb: 'глагол',
      'phrasal verb': 'фразовый глагол',
      adjective: 'прилагательное',
      adverb: 'наречие',
      phrase: 'фраза',
      other: 'другое',
      fallback: 'значение',
    },
    list: {
      pickModuleTitle: 'Выбери модуль',
      pickModuleBody: 'Очередь карточек строится по конкретному модулю. Кликни по чипу модуля сверху.',
      emptyTitle: 'Здесь будут карточки',
      emptyBody: 'Добавь первую — AI подберёт переводы и примеры.',
      createAi: 'Создать с AI',
      createManual: 'Добавить вручную',
    },
    picker: {
      eyebrow: 'Карточки',
      title: 'Куда добавляем?',
      subtitle: 'Выбери модуль — очередь и карточки строятся под него.',
      newModule: 'Новый модуль',
      empty: 'У тебя пока нет модулей — создай первый ниже.',
      loading: 'Загружаем модули…',
      wordsCount_one: '{{count}} слово',
      wordsCount_few: '{{count}} слова',
      wordsCount_many: '{{count}} слов',
      switch: 'Сменить модуль',
      create: {
        eyebrow: 'Новый модуль',
        namePlaceholder: 'например, Travel & Transport',
        descLabel: 'Описание',
        descOptional: 'по желанию',
        descPlaceholder: 'о чём модуль: например, поездки, аэропорт и отель',
        descHint: 'AI подберёт примеры карточек под эту тему',
        pairLabel: 'Языковая пара',
        pairHint: 'Слово на {{source}} → перевод на {{target}}',
        cancel: 'Отмена',
        submit: 'Создать и выбрать',
        submitting: 'Создаём…',
        error: 'Не получилось создать модуль. Попробуй другое название.',
      },
    },
    compose: {
      ai: 'Из словаря',
      manual: 'Вручную',
      hide: 'Скрыть',
      wordPlaceholder: 'английское слово',
      manualNote: 'Ручная карточка: только слово → перевод',
      manualNoteDetail:
        'Без AI не будет подсказки, упражнения «Пропущено слово» и простого предложения для прямого перевода. Работают выбор из 4 вариантов, проверка опечаток и сравнение ответа по смыслу; транскрипция и часть речи — из словаря, если слово там есть.',
      hintAi: 'Enter — отправить на генерацию',
      hintManual: 'Enter — добавить карточку',
    },
    manual: {
      boxTitle: 'Слово → твой перевод',
      wordLabel: 'Слово',
      wordPlaceholder: 'начни вводить слово…',
      translationLabel: 'Перевод',
      translationPlaceholder: 'впиши свой перевод',
      limitTitle: 'Без AI — только слово и перевод.',
      limitBody: 'Не будет подсказки, описания значения и упражнений с предложениями.',
      suggestHint: 'подсказки из словаря — кликни, чтобы подставить в перевод',
      pickTitle: 'Подставить «{{text}}» в перевод',
      notFound: 'В словаре не нашли: карточка будет без транскрипции и части речи. Впиши перевод сам.',
      lookupError: 'Словарь не ответил — впиши перевод сам, карточка создастся без словаря.',
      submit: 'Добавить',
      submitting: 'Создаём…',
    },
    lookup: {
      spotlightPlaceholder: 'английское слово, например travel',
      searching: 'ищем перевод…',
      createShort: 'создать',
      count_one: '{{count}} перевод',
      count_few: '{{count}} перевода',
      count_many: '{{count}} переводов',
      more_one: '+{{count}} перевод',
      more_few: '+{{count}} перевода',
      more_many: '+{{count}} переводов',
      notFoundTitle: 'Перевод не найден',
      notFoundHint: 'нет словарной статьи — проверь написание или добавь вручную',
      addManual: 'Добавить вручную',
      error: 'Не удалось проверить перевод — попробуй ещё раз',
      pickHint: 'выбери часть речи — можно несколько',
      createCount_one: 'Создать карточку',
      createCount_few: 'Создать {{count}} карточки',
      createCount_many: 'Создать {{count}} карточек',
      alreadyAdded: 'уже учится',
      generating: 'генерируется',
      needsAi: '+AI',
      needsAiHint: 'Этой части речи нет в готовой карточке — её допишет AI (−1 жетон)',
      allAdded: 'Все части речи этого слова уже добавлены',
      allBusy: 'Остальные части речи уже добавлены или генерируются',
      pos: {
        noun: 'существительное',
        verb: 'глагол',
        'phrasal verb': 'фразовый глагол',
        adjective: 'прилагательное',
        adverb: 'наречие',
        pronoun: 'местоимение',
        preposition: 'предлог',
        conjunction: 'союз',
        numeral: 'числительное',
        particle: 'частица',
        interjection: 'междометие',
        phrase: 'фраза',
        other: 'другое',
      },
      posShort: {
        noun: 'сущ.',
        verb: 'гл.',
        'phrasal verb': 'фраз. гл.',
        adjective: 'прил.',
        adverb: 'нар.',
        pronoun: 'мест.',
        preposition: 'предл.',
        conjunction: 'союз',
        numeral: 'числ.',
        particle: 'част.',
        interjection: 'межд.',
        phrase: 'фраза',
        other: 'др.',
      },
    },
    choose: {
      inviteTitle: 'Выбрать, что учить',
      create_one: 'Создать {{count}} карточку',
      create_few: 'Создать {{count}} карточки',
      create_many: 'Создать {{count}} карточек',
      pickSomething: 'Отметь, что учить',
      allAdded: 'Всё уже добавлено',
      // Цена — на кнопке (правило владельца), в итоге — остаток после списания (ТЗ главной § 6–7).
      createPaid_one: 'Создать {{count}} карточку · 1 жетон',
      createPaid_few: 'Создать {{count}} карточки · 1 жетон',
      createPaid_many: 'Создать {{count}} карточек · 1 жетон',
      createOnePaid: 'Создать карточку · 1 жетон',
      checking: 'Проверяем…',
      // Неразрывные пробелы: «24 жетона», «из 30», «в 00:00 МСК» не рвутся, тире не начинает строку (приёмка A1-04).
      tokensLeft_one: 'останется {{count}}\u00a0жетон из\u00a0{{limit}}',
      tokensLeft_few: 'останется {{count}}\u00a0жетона из\u00a0{{limit}}',
      tokensLeft_many: 'останется {{count}}\u00a0жетонов из\u00a0{{limit}}',
      quotaOut: 'Новые жетоны\u00a0— в\u00a0{{time}}\u00a0МСК.',
      tokensBonus: 'из несгораемых\u00a0· останется {{count}}',
      costExhausted: 'Жетоны закончились',
      back: 'Назад',
      clear: 'Очистить',
      added_one: 'Добавлено: {{count}} карточка',
      added_few: 'Добавлено: {{count}} карточки',
      added_many: 'Добавлено: {{count}} карточек',
      error: 'Словарь не ответил — можно создать карточку, AI разберёт слово сам.',
      nothingToPickMobile: 'Все переводы этого слова уже учатся или создаются',
    },
    // Выбор значений по четырём разделам словаря (макеты «Создание карточек v2», 2026-10-06).
    pick: {
      searching: 'ищем в словаре…',
      // Подпись поля и три шага с ценой (решение владельца 2026-10-16: было неясно, что это словарь и сколько стоит).
      eyebrow: 'Поиск по словарю',
      step1Title: 'Введи слово', step1Text: 'откроется статья словаря',
      step2Title: 'Отметь переводы', step2Text: 'те, что хочешь учить',
      step3Title: 'Создай карточки', step3Text: '1 жетон за 10 переводов',
      stepsClose: 'Скрыть навсегда',
      stepsExample: 'Пример: у слова run отмечено 4 перевода —', stepsExampleTotal: '1 жетон',
      strip: 'Отметь, что учить. Слово и каждая фраза станут отдельными карточками.',
      yandex: 'по данным Яндекс.Словаря',
      yandexShort: 'по данным Яндекс.Словаря',
      noActiveRare: 'Основных значений нет — это слово обычно учат во фразе',
      noActiveNone: 'Отдельного перевода нет — выбери фразу',
      active: 'Активно используются',
      other: 'Другие',
      rareSection: 'Редкие',
      rareReadOnly: 'Встречаются редко — в карточки не попадают. Нужное значение можно добавить вручную.',
      titleRare: 'Редкое значение — в карточки не попадает',
      phrases: 'Фразы',
      phrasalVerbs: 'Фразовые глаголы',
      selected: 'выбрано {{n}}',
      rarePhrases: 'Фразы и фразовые глаголы',
      peekClose: 'Закрыть',
      more: 'ещё {{n}}',
      less: 'свернуть',
      tagLearned: 'учишь',
      tagGenerating: 'создаётся',
      titleOn: 'Убрать из выбора',
      titleOff: 'Выбрать значение',
      titleLearned: 'Это значение ты уже учишь',
      titleGenerating: 'Карточка уже создаётся',
      titleLimit: 'Можно выбрать до {{limit}} значений за раз — сними отметку с другого',
      synonyms: 'Синонимы: ',
      rowLearned: 'Эту фразу ты уже учишь',
      rowSelect: 'Выбрать — станет отдельной карточкой',
      rowShow: 'Показать значения',
      rowHide: 'Свернуть',
      moreSenses_one: '+{{count}} значение',
      moreSenses_few: '+{{count}} значения',
      moreSenses_many: '+{{count}} значений',
      willCreate_one: 'Создастся {{count}} карточка',
      willCreate_few: 'Создастся {{count}} карточки',
      willCreate_many: 'Создастся {{count}} карточек',
      allLearned: 'Все значения уже в твоих карточках',
      nothing: 'Ничего не выбрано',
      pickAbove: 'Отметь значения выше',
      count: '{{n}} из {{limit}}',
      countMax: '{{limit}} из {{limit}} · больше за раз нельзя',
      countMaxShort: '{{limit}} из {{limit}} · максимум',
      moreCards: ' · ещё {{n}}',
      priceNone: 'Без жетона',
      priceNoneSub: 'карточки уже готовы',
      createOne: 'Создать карточку',
      pickSense: 'Выбери значение',
      notFoundTitle: 'Не нашли «{{word}}» в словаре',
      notFoundBody: 'проверь написание или добавь перевод вручную — карточка будет без транскрипции, примера и подсказки',
      addManual: 'Добавить вручную',
      addManualHint: 'слово → свой перевод, без ИИ',
      coachBold: 'Зажми значение',
      coachRest: ', чтобы подсмотреть пример, не отмечая. Отпустишь — подсказка закроется.',
      coachHide: 'Понятно, скрыть подсказку',
      extraOther_one: 'другое',
      extraOther_few: 'других',
      extraOther_many: 'других',
      extraRare_one: 'редкое',
      extraRare_few: 'редких',
      extraRare_many: 'редких',
      extraPhrases_one: 'фраза',
      extraPhrases_few: 'фразы',
      extraPhrases_many: 'фраз',
      extraPhrasalVerbs_one: 'фразовый глагол',
      extraPhrasalVerbs_few: 'фразовых глагола',
      extraPhrasalVerbs_many: 'фразовых глаголов',
      // «и редкие — внутри» не рвётся: на 320–375 px тире начинало вторую строку (R2-07).
      inviteSub: 'значения, фразы и\u00a0редкие\u00a0—\u00a0внутри',
      skipped: 'Не создались: {{list}} — уже учишь или нет в словаре',
    },
    // Пометы употребления (Oxford) короткими подписями.
    marks: {
      informal: 'разг.',
      formal: 'офиц.',
      slang: 'сленг',
      literary: 'книжн.',
      oldFashioned: 'устар.',
      disapproving: 'неодобр.',
      approving: 'одобр.',
      humorous: 'шутл.',
      specialist: 'спец.',
      offensive: 'оскорб.',
      british: 'брит.',
      american: 'амер.',
      australian: 'австрал.',
      indian: 'инд.',
      newZealand: 'новозел.',
      southAfrican: 'южноафр.',
      scottish: 'шотл.',
      irish: 'ирл.',
      canadian: 'канад.',
      usuallyPlural: 'обычно мн. ч.',
      plural: 'мн. ч.',
      uncountable: 'неисч.',
      beforeNoun: 'перед сущ.',
      afterVerb: 'после глагола',
      usuallyPassive: 'обычно в пассиве',
      singular: 'ед. ч.',
      transitive: 'перех.',
      intransitive: 'неперех.',
      countable: 'исч.',
    },
    composer: {
      moduleLabel: 'Модуль',
      wordLabel: 'Английское слово',
      wordHintAi: 'AI подберёт варианты перевода и примеры',
      wordHintManual: 'без проверки на опечатки и AI-разбора',
      translationLabel: 'Перевод',
      translationPlaceholder: 'стремление',
      levelLabel: 'Уровень',
      submitting: 'Создаём…',
      submitAi: 'Создать карточку',
      submitManual: 'Добавить карточку',
    },
    generatingCount_one: 'Генерируем {{count}} карточку',
    generatingCount_few: 'Генерируем {{count}} карточки',
    generatingCount_many: 'Генерируем {{count}} карточек',
    generatingSlow: 'чем больше карточек, тем дольше — до пары минут',
    // Одна плашка на все генерирующиеся карточки (2026-10-06).
    generation: {
      title: 'Генерация',
      progress: 'готово {{done}} из {{total}}',
      cards_one: '{{count}} карточка',
      cards_few: '{{count}} карточки',
      cards_many: '{{count}} карточек',
      status: {
        generating: 'генерируется',
        ready: 'готова',
        failed: 'не получилось',
      },
      remove: 'убрать',
      allDone: 'Всё готово',
      steps: ['Анализирую слово', 'Подбираю значения', 'Пишу примеры', 'Перевожу предложения', 'Финальная проверка'],
    },
    ready: {
      badge: 'Готова к тренировке',
      manualPill: 'создана вручную',
      remove: 'Убрать',
      openInModule: 'Открыть в модуле',
    },
    garbage: {
      heading: 'Слово не распознано',
      fallbackMessage: 'Это не похоже на английское слово или выражение. Проверь, не ошибся ли ты при вводе, и попробуй ещё раз.',
      replaceWith: 'Заменить на',
      placeholder: 'например, deployment',
      enterHint: 'Enter — заменить, или нажми кнопку ниже',
      delete: 'Удалить',
      replacing: 'Заменяем…',
      replace: 'Заменить',
    },
    problem: {
      heading: 'Ошибка генерации',
      fallbackMessage: 'AI не справился с генерацией. Попробуй ещё раз.',
      delete: 'Удалить',
      retry: 'Повторить',
    },
    toast: {
      cardCreated: 'Карточка создана',
      senseQueued: 'Добавили ещё одну часть речи: {{front}} → {{translation}}. Придёт вместе с первой.',
      senseAdded: 'Добавили ещё одну часть речи: {{front}} → {{translation}}',
      posQueued: 'Дописываем часть речи: {{front}} → {{translation}}. Пришлём уведомление, когда будет готово.',
      cardRemoved: 'Карточка «{{front}}» убрана из очереди',
      cardHidden: 'Карточка «{{front}}» удалена — вернуть можно во вкладке «Удалённые»',
      deleteFailedTitle: 'Не получилось удалить',
      deleteOldFailedTitle: 'Не получилось удалить старую карточку',
      alreadyInModuleTitle: '«{{front}}» уже в модуле',
      alreadyInModuleDesktop: 'Карточка с этим словом уже здесь — найди её внизу списка.',
      alreadyInModuleMobile: 'Карточка с этим словом уже здесь — найди её внизу списка.',
      recreateFailed: 'Старую карточку убрали, но новую не получилось создать. Добавь её заново.',
      fixAppliedTitle: 'Применили исправление',
      fixAppliedDesc: '«{{front}}» → «{{newFront}}». Генерируем заново.',
      keptTitle: 'Оставили как есть',
      keptDesc: 'Карточка «{{front}}» сохранена в модуле без изменений.',
      retrying: 'Повторяем генерацию «{{front}}»…',
      retryingShort: 'Повторяем «{{front}}»…',
      regenStartedTitle: 'Запустили генерацию',
      regenStartedDesc: 'AI разберёт «{{front}}» — будет несколько значений и пример.',
      errorTitle: 'Ошибка',
      feedbackThanksTitle: 'Спасибо за фидбэк',
      feedbackThanksDesc: 'Жалоба на «{{front}}» получена — посмотрим, что не так.',
      cardSavedTitle: 'Карточка сохранена',
      cardSavedDesc_one: '«{{front}}» — {{count}} перевод.',
      cardSavedDesc_few: '«{{front}}» — {{count}} перевода.',
      cardSavedDesc_many: '«{{front}}» — {{count}} переводов.',
      creating: '«{{front}}» создаётся…',
      wordReplacedTitle: 'Заменили слово',
      wordReplacedDesc: '«{{front}}» → «{{trimmed}}». Генерируем заново.',
    },
    errors: {
      emptyFields: 'Заполни оба поля',
      alreadyAdded: 'Слово уже есть в одном из твоих модулей',
      alreadyAddedShort: 'Слово уже есть в этом модуле',
      alreadyAddedIn_one: 'Слово уже есть в модуле {{names}}',
      alreadyAddedIn_few: 'Слово уже есть в модулях {{names}}',
      alreadyAddedIn_many: 'Слово уже есть в модулях {{names}}',
      dailyLimit: 'Жетоны на сегодня закончились',
      dailyLimitDetailed: 'Жетоны на сегодня закончились. Создавай карточки вручную или перейди на тариф повыше.',
      dailyLimitQuota: 'Жетоны на сегодня закончились ({{used}}/{{limit}}). Новые придут в {{time}} — а пока можно создавать карточки вручную.',
      dailyLimitRegen: 'Жетоны на сегодня закончились — новые придут завтра, или перейди на тариф повыше.',
      notInDictionary: 'Слова нет в словаре — подготовить карточку не получится, жетон не спишется. Проверь написание или добавь карточку вручную.',
      // 400 NOT_IN_DICTIONARY у «Повторить» (ТЗ главной § 23.5): карточка уже есть — проверять написание нечего,
      // жетон не списан. Запись — строкой под элементом, /cards/new — тостом.
      regenNotInDictionary: 'Слова нет в словаре — повторить не получится, жетон не списан. Добавь карточку вручную.',
      generationInProgress: 'Это слово ещё генерируется. Подожди несколько секунд и добавь часть речи снова — жетон не списан.',
      // 409 CARD_GENERATION_IN_PROGRESS у ручной карточки (ТЗ главной § 23.1): главная и /cards/new.
      generationInProgressManual: 'Это слово уже создаётся в этом модуле. Если не получится, добавишь его вручную.',
      rateLimit: 'Слишком много запросов подряд — подожди минуту.',
      moduleNotFound: 'Модуль удалён — выбери другой.',
      emailNotVerified: 'Сначала подтверди почту — ссылка в письме.',
      serverUncertain: 'Сервер не ответил — проверь список, прежде чем создавать ещё раз.',
      network: 'Нет связи с сервером',
      networkRetry: 'Нет связи с сервером — повтори позже.',
      tryAgain: 'Попробуй ещё раз.',
      unknownCreate: 'Не удалось создать карточку',
      deleteFailedShort: 'Не получилось удалить',
      deleteOldFailedShort: 'Не получилось удалить старую карточку.',
      createNewFailed: 'Не удалось создать новую карточку.',
      notRegeneratable: 'Карточка уже в AI-обработке или готова — нечего регенерировать.',
      notInAccount: 'Эта карточка не в твоей учётке.',
      regenFailed: 'Не получилось запустить регенерацию.',
      notReportable: 'Эту карточку нельзя пометить как «неверный перевод» — она ещё не готова.',
      notFoundInAccount: 'Карточка не найдена в твоей учётке.',
      reportFailed: 'Не получилось отправить жалобу. Попробуй ещё раз.',
    },
  },
  triage: {
    status: {
      typo: 'Опечатка',
      garbage: 'Не распознано',
      error: 'Ошибка',
      aiError: 'Ошибка AI',
      awaitingSelection: 'Выбери переводы',
    },
    row: {
      delete: 'Удалить',
      deleteCard: 'Удалить карточку',
      suggestions: 'подсказки:',
      retry: 'Повторить',
      placeholderCorrectWord: 'правильное слово',
      placeholderFix: 'исправить',
      replace: 'Заменить',
      apply: 'Применить',
    },
    awaiting: {
      savesToModule: 'Сохранится в модуль:',
      alsoIn_one: 'карточка также есть в {{count}} другом',
      alsoIn_few: 'карточка также есть в {{count}} других',
      alsoIn_many: 'карточка также есть в {{count}} других',
    },
    empty: {
      title: 'Очередь пуста',
      resolvedPrefix: 'Ты разобрал',
      resolvedSuffix_one: '{{count}} карточку — отличная работа.',
      resolvedSuffix_few: '{{count}} карточки — отличная работа.',
      resolvedSuffix_many: '{{count}} карточек — отличная работа.',
      back: '← Назад к карточкам',
    },
    toast: {
      moduleUnknown: 'Не удалось определить модуль карточки.',
      noConnection: 'Нет связи с сервером — повтори позже.',
      tryAgain: 'Попробуй ещё раз.',
      deleteOldFailed: 'Не получилось удалить старую',
      removeOldFailed: 'Не получилось убрать старую',
      deleteFailed: 'Не получилось удалить',
      alreadyInModuleTitle: '«{{word}}» уже в модуле',
      alreadyInModuleMessage: 'Карточка с этим словом уже добавлена раньше — открой модуль и работай с ней.',
      replaceCreateFailed: 'Старую убрали, новую создать не получилось. Добавь её заново.',
      retryGenFailed: 'Старую убрали, повторить генерацию не получилось.',
      savedTitle: 'Сохранили переводы',
      savedMessage: 'Выбрано {{count}} для «{{word}}».',
      saveStateNotFound: 'Карточка не найдена в твоём прогрессе.',
      saveWrongCard: 'Некоторые переводы не принадлежат этой карточке.',
      saveFailed: 'Не получилось сохранить переводы. Попробуй ещё раз.',
      saveErrorTitle: 'Ошибка сохранения',
    },
    header: {
      backToCards: '← Карточки',
      eyebrow: 'Разбор очереди',
      title: 'Карточки, которые ждут решения',
      sub: 'Все опечатки и нераспознанные слова со всех твоих модулей в одном месте. Поправь — Enter применяет, клик по подсказке подставляет её в инпут.',
    },
    progress: {
      label: 'Прогресс',
      remaining: 'осталось',
      allDone: 'всё разобрано',
    },
    filter: {
      allModules: 'Все модули',
    },
    hints: {
      apply: 'применить',
      clickSuggestion: 'клик по подсказке — подставить',
    },
  },
  notifications: {
    title: 'Уведомления',
    batchReady_one: 'Готова {{count}} карточка',
    batchReady_few: 'Готово {{count}} карточки',
    batchReady_many: 'Готово {{count}} карточек',
    batchMore_one: '{{list}} и ещё {{count}}',
    batchMore_few: '{{list}} и ещё {{count}}',
    batchMore_many: '{{list}} и ещё {{count}}',
    sub: 'Все события за последнее время — от системы и обучения.',
    unreadCount_one: '{{count}} непрочитанное',
    unreadCount_few: '{{count}} непрочитанных',
    unreadCount_many: '{{count}} непрочитанных',
    allRead: 'Все прочитаны',
    markAllRead: 'Отметить все прочитанными',
    hideAll: 'Скрыть все',
    hideAllConfirm: 'Скрыть все? Нажми ещё раз',
    filters: {
      all: 'Все',
      unread: 'Непрочитанные',
      read: 'Прочитанные',
    },
    loadingMore: 'Загружаем…',
    empty: {
      title: 'Здесь пока тихо',
      sub: 'Уведомления появятся, когда что-то произойдёт — окончание сессии, обновление модуля, системные сообщения.',
    },
    emptyUnread: 'Непрочитанных уведомлений нет.',
    emptyRead: 'Прочитанных уведомлений пока нет.',
    error: 'Не удалось загрузить уведомления. Попробуй обновить страницу.',
    item: {
      unreadDot: 'непрочитано',
      open: 'Открыть',
      markRead: 'Отметить прочитанным',
      hide: 'Скрыть',
    },
    relativeNow: 'только что',
    relativeMin_one: '{{count}} мин назад',
    relativeMin_few: '{{count}} мин назад',
    relativeMin_many: '{{count}} мин назад',
    relativeHour_one: '{{count}} ч назад',
    relativeHour_few: '{{count}} ч назад',
    relativeHour_many: '{{count}} ч назад',
    relativeDay_one: '{{count}} день назад',
    relativeDay_few: '{{count}} дня назад',
    relativeDay_many: '{{count}} дней назад',
  },
  emptyModules: {
    full: {
      kicker: 'Здесь пока пусто',
      title: 'Создай свой первый модуль',
      body: 'Добавь свой набор слов или возьми готовый модуль из общей библиотеки для первой тренировки.',
      cta: 'Создать модуль',
      secondary: 'Открыть готовые',
    },
    locked: {
      kicker: 'Здесь пока пусто',
      title: 'Подтверди почту, чтобы создавать свои модули',
      // Главная со строкой создания: просьба о почте — в самой строке, здесь своей нет (ТЗ главной § 10).
      titleDock: 'Начни с готового модуля',
      body: 'Добавь готовый модуль из общей библиотеки и начни первую тренировку.',
      cta: 'Открыть готовые модули',
    },
    // ТЗ демо 1.4 (B3, R9): удалённые модули можно вернуть; надзаголовок, заголовок и кнопка одного
    // удалённого — moduleDetail.restore.*.
    restore: {
      // Название — в конце фразы: после него, обрезанного в две строки, строка не начинается с «—» (A2-04).
      body: 'В\u00a0удалённых: «{{name}}». Карточки и\u00a0прогресс в\u00a0нём сохранились.',
      busy: 'Восстанавливаем…',
      kickerMany: 'Модули удалены',
      titleMany: 'Удалённые модули можно вернуть',
      bodyMany: 'Карточки и прогресс в них сохранились.',
      ctaMany: 'Открыть удалённые',
    },
  },
  // Список слов модуля с карточкой (entities/Word · WordBrowser).
  wordBrowser: {
    card: 'Карточка',
    prev: 'Предыдущая карточка',
    next: 'Следующая карточка',
    sheetPrev: '← Назад',
    sheetNext: 'Дальше →',
    close: 'Закрыть',
    keysHint: 'листать карточки',
    meaning: 'Значение',
    example: 'Пример',
    hint: 'Подсказка',
    rare: 'Редкие',
  },
  // Карточка — слово или фраза, перевод внутри неё — «перевод» (решение владельца 2026-10-20, ТЗ главной
  // § 22.13): каждый перевод по-прежнему отдельное задание в тренировке, меняются только слова.
  sessionSenses: {
    pill_one: '{{count}} перевод',
    pill_few: '{{count}} перевода',
    pill_many: '{{count}} переводов',
    pillTitle: 'Каждый перевод — отдельное задание в тренировке',
    title: 'Переводы · {{total}}',
    remove: 'Удалить перевод',
    removeLast: 'Последний перевод — слово уберётся из модуля',
    removeConfirm: 'Удалить?',
    removeWordConfirm: 'Убрать слово?',
    more_one: 'Показать ещё {{count}} перевод',
    more_few: 'Показать ещё {{count}} перевода',
    more_many: 'Показать ещё {{count}} переводов',
    collapse: 'Свернуть',
    otherTitle: 'Редкие переводы · {{count}}',
    otherNotePanel: 'В тренировку не попадают',
    definitionLabel: 'Смысл',
    definitionTitle: 'Что значит слово в этом переводе. В тренировке показывается после ответа',
    saveError: 'Не удалось удалить перевод — попробуй ещё раз',
  },
  library: {
    searchPlaceholder: 'Поиск по названию или описанию…',
    official: 'От Lomora',
    community: 'От сообщества',
    moduleCount_one: '{{count}} модуль',
    moduleCount_few: '{{count}} модуля',
    moduleCount_many: '{{count}} модулей',
    moduleCount_other: '{{count}} модуля',
    cardCount_one: '{{count}} карточка',
    cardCount_few: '{{count}} карточки',
    cardCount_many: '{{count}} карточек',
    installCount_one: '{{count}} установка',
    installCount_few: '{{count}} установки',
    installCount_many: '{{count}} установок',
    installCount_other: '{{count}} установки',
    role: {
      official: 'Команда Lomora',
      community: 'Сообщество',
    },
    verified: 'Модуль команды Lomora',
    add: 'Добавить',
    addNamed: 'Добавить «{{name}}»',
    addedShort: '✓ Добавлено',
    addedToast: '«{{name}}» теперь в твоих модулях',
    fork: 'Добавить себе',
    added: '✓ Уже добавлено',
    forkError: 'Не удалось добавить модуль. Попробуй ещё раз.',
    share: 'Поделиться',
    shareDone: '✓ ссылка скопирована',
    empty: 'По запросу ничего не нашлось — попробуй изменить его.',
    emptyAll: 'Готовых модулей пока нет — скоро добавим. А свои слова можно добавить в «Моих модулях».',
    detail: {
      back: 'все готовые модули',
      cardsHeading: 'Карточки в модуле · {{n}}',
      noCards: 'В этом модуле пока нет карточек.',
      notFound: 'Готовый модуль не найден',
      pickHint: 'Нажми на слово — карточка откроется справа',
    },
  },
  dashboard: {
    // Неразрывный пробел: balance на 320 px разрывал «Добрый / день, Даша» (приёмка A1-12).
    greeting: 'Добрый\u00a0день, {{name}}',
    // Подзаголовок, когда строка создания внизу открыта (ТЗ главной § 11); иначе — training.greetingSub.
    greetingSub: 'Вот что можно сделать сегодня.',
    donorBadge: 'Поддержал проект',
    // Знакомство после онбординга (DashboardTour): три шага по разделам; заголовки шагов — подписи самих разделов.
    tour: {
      counter: '{{n}} из {{total}}',
      next: 'Далее',
      done: 'Понятно',
      skip: 'Пропустить',
      home: 'Что сделать сегодня: тренировка, задание дня и миссия.',
      words: 'Твои модули и готовые наборы. Здесь же создаёшь новые карточки — в строке внизу.',
      grammar: 'Правила английского по шагам: прочитай — и сразу потренируйся. За упражнения — звёзды.',
      game: 'Разговоры с жителями Лондона — голосом. За миссии дают жетоны.',
    },
    active: {
      kicker: 'Тренировка не закончена',
      bossReady: 'Остался финальный матч',
      bossSub: 'Собери пройденные слова в пары.',
      toFinal: 'Перейти к финалу',
      remaining_one: 'Осталась {{count}} карточка',
      remaining_few: 'Осталось {{count}} карточки',
      remaining_many: 'Осталось {{count}} карточек',
      redoInline: '{{count}} к повторению',
      continue: 'Продолжить тренировку',
    },
    kpis: {
      streak: { title: 'Стрик', sub_one: 'день подряд', sub_few: 'дня подряд', sub_many: 'дней подряд' },
      words: { title: 'Слов в памяти', sub: '+{{n}} за неделю' },
      accuracy: { title: 'Точность', sub: 'за последние 7 дней' },
      today: { title: 'Сегодня', sub_one: 'до цели {{n}} слово', sub_few: 'до цели {{n}} слова', sub_many: 'до цели {{n}} слов' },
    },
    modules: {
      chips: {
        deleted: 'удалён',
      },
    },
    // Новая главная (макет владельца «3 · Дашборд», 2026-10-22).
    home: {
      reminder: {
        title: 'Напоминания выключены',
        text: 'Включи — пришлём короткое письмо в {{hour}}:00 по Москве, если давно не было тренировки.',
        on: 'Включить',
        later: 'Позже',
        saved: 'Напоминания включены',
        error: 'Не удалось включить напоминания. Попробуй ещё раз.',
      },
      // Баннер игры под тренировкой (решение владельца 2026-10-22: игра — главный повод вернуться).
      game: {
        play: 'Играть',
        resume: 'Продолжить игру',
        // Число не отрывается от подписи: на 320 px «3» уходила на вторую строку одна (ТЗ перепланировки, P1-4).
        endings: 'Концовки:\u00a0{{n}} из\u00a0{{total}}',
        boss: 'Ошибок для босса:\u00a0{{count}}',
      },
      // Метки строки «Миссия дня» в плашке «На сегодня» (с 2026-10-23; до того — своя плашка рядом с баннером игры).
      mission: {
        upTo_one: 'до +{{count}} жетона',
        upTo_few: 'до +{{count}} жетонов',
        upTo_many: 'до +{{count}} жетонов',
        upTo_other: 'до +{{count}} жетона',
        noReward: 'Жетоны не получены',
      },
      // «Задание дня» и «Миссия дня» одной плашкой (решение владельца 2026-10-23): кнопки короткие — строка узкая.
      dailies: {
        title: 'На сегодня',
        take: 'Получить',
        taking: 'Подбираем…',
        learn: 'Учить',
        start: 'Начать',
        starting: 'Готовим…',
        resume: 'Дальше',
        result: 'Итоги',
        steps: 'Шаг {{n}} из {{total}}',
      },
      // Где создать карточку и модуль — «Слова и модули» (решение владельца 2026-10-23).
      create: {
        title: 'Встретилось новое слово?',
        text: 'Сохрани его в карточку — перевод и пример найдём сами.',
        card: 'Создать карточку',
        module: 'Новый модуль',
      },
      grammar: {
        kicker: 'Грамматика',
        left_one: 'Ещё {{count}} тема до награды',
        left_few: 'Ещё {{count}} темы до награды',
        left_many: 'Ещё {{count}} тем до награды',
        left_other: 'Ещё {{count}} темы до награды',
        reward_one: '+{{count}} жетон',
        reward_few: '+{{count}} жетона',
        reward_many: '+{{count}} жетонов',
        reward_other: '+{{count}} жетона',
        ofStep: '{{done}} из {{step}}',
        hint: 'Темы — в любом порядке. Тема засчитывается после упражнения 1.',
        plain: 'Учи грамматику по темам',
        allDone: 'Все темы пройдены',
        continue: 'Продолжить: {{title}}',
        start: 'Начать: {{title}}',
        all: 'Все темы',
      },
    },
  },
  units: {
    title: 'Модули',
    summaryLoading: 'загружаем модули…',
    totalCount_one: '{{count}} модуль',
    totalCount_few: '{{count}} модуля',
    totalCount_many: '{{count}} модулей',
    searchPlaceholder: 'Поиск по названию…',
    createModule: 'Создать модуль',
    empty: 'Ничего не подходит под фильтр',
    filters: {
      all: 'Все',
      active: 'Активные',
      paused: 'На паузе',
      deleted: 'Удалённые',
    },
    deletedNotice: 'Удалённые модули хранятся здесь. Любой можно восстановить вместе с карточками и прогрессом.',
  },
  // «Слова и модули» (решение владельца 2026-10-23): свои и готовые модули, прогресс, «Недавно добавленные» и
  // строка создания внизу.
  words: {
    title: 'Слова и модули',
    sub: 'Твои модули и все слова. Новые слова добавляй в строке внизу.',
    subLocked: 'Твои модули и все слова.',
    composerTitle: 'Создать карточку',
    modulesTitle: 'Все модули',
    readyTitle: 'Готовые наборы',
    // Без подтверждённой почты, пока бесплатная карточка не потрачена (2026-11-02).
    guestCardHint: 'Первая карточка\u00a0— сразу, следующие\u00a0— после подтверждения почты.',
    readyLink: 'Готовые наборы слов',
    trainError: 'Не получилось начать тренировку. Попробуй ещё раз.',
    // Полка модулей на телефоне (вариант B, 2026-10-28).
    shelf: {
      title: 'Модули',
      all: 'Все',
      newModule: 'Новый модуль',
      ready: 'Готовые наборы',
    },
    // «Слова»: все слова ученика, последние изменения сверху.
    list: {
      title: 'Слова',
      find: 'Найти',
      search: 'Слово или перевод',
      cancel: 'Отмена',
      filterLabel: 'Какие слова показать',
      kinds: {
        all: 'Все',
        new: 'Новые',
        repeat: 'Повторить',
      },
      status: {
        new: 'новое',
        repeat: 'повторить',
        today: 'сегодня',
      },
      hint: 'Нажми на слово\u00a0— покажем пример, смысл и все переводы.',
      rowAria: '{{word}}: {{translations}}, модуль «{{module}}». Открыть подробности',
      empty: 'Здесь появятся твои слова. Добавь первое в строке внизу\u00a0— покажем, куда оно легло.',
      noMatch: 'Ничего не нашли',
      moduleEmpty: 'В этом модуле пока нет слов.',
      allWords: 'Показать все слова',
      openModule: 'Открыть модуль',
      // Заголовки колонок таблицы на компьютере.
      cols: {
        word: 'Слово',
        translation: 'Перевод',
        module: 'Модуль',
        status: 'Состояние',
      },
      loadError: 'Слова не загрузились.',
      retry: 'Повторить',
      more: 'Показать ещё',
      loading: 'Загружаем…',
    },
    // Плашка над колонками на компьютере.
    toolbar: {
      all: 'Все слова',
      searchIn: 'Найти слово в модуле',
      empty: 'Пока нет слов\u00a0— добавь первое в строке внизу',
    },
    sheet: {
      kicker: 'Модуль «{{module}}»',
      openModule: 'Открыть модуль',
    },
    mine: {
      repeat_one: 'Повторить {{count}} слово',
      repeat_few: 'Повторить {{count}} слова',
      repeat_many: 'Повторить {{count}} слов',
      repeat_other: 'Повторить {{count}} слова',
      train: 'Учить «{{name}}»',
      trainTitle: 'Тренировка на сегодня',
      learn: 'Учить',
      select: 'Показать слова модуля «{{name}}»',
      // Добавлены в модуль сегодня и ещё не тренировались.
      fresh_one: '{{count}} новое · сегодня',
      fresh_few: '{{count}} новых · сегодня',
      fresh_many: '{{count}} новых · сегодня',
      fresh_other: '{{count}} новых · сегодня',
    },
    // По истории тренировок: «пройдено» — слово отвечали хотя бы раз (как «Сегодня пройдено», 2026-10-21).
    progress: {
      title: 'Твой прогресс',
      passed_one: 'слово пройдено',
      passed_few: 'слова пройдено',
      passed_many: 'слов пройдено',
      passed_other: 'слова пройдено',
      ofReady_one: 'из {{count}} слова в твоих модулях',
      ofReady_few: 'из {{count}} слов в твоих модулях',
      ofReady_many: 'из {{count}} слов в твоих модулях',
      ofReady_other: 'из {{count}} слова в твоих модулях',
      empty: 'Добавь слова в модуль — здесь будет видно, сколько уже пройдено.',
      today: 'Сегодня',
      accuracy: 'Точность за 7 дней',
      // Телефон: прогресс одной строкой под заголовком.
      line_one: '{{passed}} из\u00a0{{count}} слова пройдено',
      line_few: '{{passed}} из\u00a0{{count}} слов пройдено',
      line_many: '{{passed}} из\u00a0{{count}} слов пройдено',
      line_other: '{{passed}} из\u00a0{{count}} слова пройдено',
      lineAccuracy: 'точность\u00a0{{value}}%',
    },
  },
  moduleDetail: {
    backToUnits: 'все модули',
    notFound: 'Модуль не найден',
    kicker: 'твой набор слов',
    active: 'активный',
    paused: 'на паузе',
    visibility: {
      public: 'Публичный',
      private: 'Приватный',
      publicHint: 'Виден другим пользователям во вкладке «Готовые»',
      privateHint: 'Виден только тебе',
    },
    share: {
      cta: 'Поделиться',
      copying: '…',
      done: 'Скопировано',
      privateBlocked: 'Сначала сделай модуль публичным',
      toastTitle: 'Ссылка скопирована',
      toastBody: 'Можно вставить в чат, почту или соцсети.',
      toastError: 'Не получилось скопировать ссылку',
    },
    menu: {
      aria: 'Действия с модулем',
      delete: 'Удалить модуль',
    },
    danger: {
      confirmKicker: 'Удаление',
      confirmTitle: 'Удалить «{{name}}»?',
      confirmBody:
        'Модуль попадёт в раздел «Удалённые». Оттуда его можно вернуть вместе с карточками и прогрессом.',
      confirmCta: 'Да, удалить',
      cancel: 'Отмена',
      error: 'Не получилось удалить. Попробуй ещё раз.',
      toastTitle: 'Модуль удалён',
      toastBody: '«{{name}}» перенесён в «Удалённые». Восстановить можно в любой момент.',
    },
    restore: {
      kicker: 'Модуль удалён',
      title: 'Модуль можно вернуть',
      body: 'Восстанови его, чтобы снова тренироваться, — карточки и прогресс сохранились.',
      inTraining: 'Модуль «{{name}}» удалён. Восстанови его, чтобы потренироваться, — карточки и прогресс сохранились.',
      cta: 'Восстановить модуль',
      error: 'Не получилось восстановить. Попробуй ещё раз.',
      toastTitle: 'Модуль восстановлен',
      toastBody: '«{{name}}» снова доступен. Прогресс по карточкам сохранён.',
    },
    studyThis: 'Начать тренировку',
    cram: 'Тренировка',
    cramTooltip:
      'Выбери упражнения и карточки модуля, пройди тренировку и финальный матч.',
    acquaint: 'Ознакомление',
    cramHero: {
      kicker: 'Тренировка',
      title: 'Потренируй слова этого модуля',
      sub: 'Выбери упражнения и карточки, затем начни тренировку.',
    },
    kpis: {
      progress: { title: 'Прогресс', sub_one: '{{n}} слово всего', sub_few: '{{n}} слова всего', sub_many: '{{n}} слов всего' },
      learned: { title: 'Выучено', sub: 'из {{n}}' },
      inReview: { title: 'На повторении', sub: 'в активном цикле' },
    },
    words: {
      title_one: 'Слово в модуле · {{n}}',
      title_few: 'Слова в модуле · {{n}}',
      title_many: 'Слов в модуле · {{n}}',
      createCard: 'Создать карточку',
      createShort: 'Создать',
      search: 'поиск…',
      empty: 'Ничего не нашлось',
      filters: {
        all: 'Все',
        hidden: 'Удалённые',
        review: 'К ревью',
        new: 'Новые',
        learned: 'Выученные',
      },
      hide: 'Удалить из модуля',
      restore: 'Восстановить',
      resolve: 'Разобрать',
      needActionText: 'Алгоритм не смог разобрать это слово автоматически — посмотри и реши, что делать.',
      hidden: 'Слово «{{word}}» удалено',
      restored: 'Слово «{{word}}» восстановлено',
      actionFailed: 'Не удалось. Попробуй ещё раз',
      chips: {
        review: 'к ревью',
        new: 'новое',
        learned: 'выучено',
        needAction: 'требует действия',
      },
      dot: {
        manual: 'создано вручную',
        ready: 'разобрано',
      },
      moreSenses: ' · ещё {{count}}',
      pos: {
        noun: 'сущ.',
        verb: 'глаг.',
        'phrasal verb': 'фраз. гл.',
        adjective: 'прил.',
        adverb: 'нареч.',
        phrase: 'фраза',
        other: 'др.',
      },
      senses: {
        more_one: '+{{count}} значение',
        more_few: '+{{count}} значения',
        more_many: '+{{count}} значений',
        kicker_one: '{{count}} значение',
        kicker_few: '{{count}} значения',
        kicker_many: '{{count}} значений',
        example: 'Пример',
      },
    },
    needActionBanner: {
      title_one: '{{count}} карточка требует действия',
      title_few: '{{count}} карточки требуют действия',
      title_many: '{{count}} карточек требуют действия',
      body: 'Алгоритм не смог разобрать эти слова автоматически — посмотри и реши, что делать.',
      cta: 'Открыть',
    },
  },
  preview: {
    back: 'модуль',
    kicker: 'ознакомление',
    of: 'из',
    tag: { word: 'слово', translation: 'перевод' },
    show: { word: 'Показать слово', translation: 'Показать перевод' },
    hide: 'Скрыть',
    hint: {
      showWord: 'Space или клик — показать слово',
      showTranslation: 'Space или клик — показать перевод',
      backToWord: 'клик — назад к слову',
      backToTranslation: 'клик — назад к переводу',
    },
    footnote: 'Листай карточки, чтобы познакомиться со словами.',
    toCram: 'Перейти к практике →',
    prev: 'назад',
    next: 'далее',
    loading: 'Загружаем…',
    manual: {
      badge: 'вручную',
      note: 'Эта карточка создана вручную — у неё нет примеров, смысла и подсказки, которые есть у AI-карточек; транскрипция — из словаря, если слово там есть.',
      aria: 'Карточка создана вручную, с ограничениями',
    },
    done: {
      title_one: 'Просмотрена {{count}} карточка',
      title_few: 'Просмотрено {{count}} карточки',
      title_many: 'Просмотрено {{count}} карточек',
      sub: 'Теперь можно закрепить их в тренировке или полистать ещё раз.',
      again: 'Ещё раз',
      toCram: 'К практике →',
    },
    empty: {
      title: 'В модуле пока нет готовых карточек',
      sub: 'Карточки появятся здесь, как только слова сгенерируются.',
      back: '← к модулю',
    },
  },
  actionRequired: {
    backToModule: 'к модулю',
    kicker: '«{{module}}»',
    title: 'Требуют действия',
    sub_one: '{{count}} проблемная карточка — реши, что делать.',
    sub_few: '{{count}} проблемные карточки — реши, что делать.',
    sub_many: '{{count}} проблемных карточек — реши, что делать.',
    subEmpty: 'Здесь пусто — все карточки в модуле разобраны без проблем.',
    empty: {
      title: 'Ничего не требует действия',
      sub: 'Когда алгоритм не справится с разбором слова — карточка появится здесь.',
    },
    row: {
      chip: 'требует действия',
      chipTypo: 'возможна опечатка',
      reason: 'Что не так',
      suggestions: 'Выбери правильный вариант',
      hint: 'Или примени действие снизу.',
      keep: 'Оставить как есть',
      edit: 'Редактировать',
      delete: 'Удалить',
    },
    toasts: {
      keptTitle: 'Действие сохранено',
      keptBody: '«{{word}}» оставлено как есть. Бэкенд для этого действия пока не подключён.',
      editTitle: 'Редактирование',
      editBody: 'Открытие редактора для «{{word}}» пока не подключено к бэку.',
      deleteTitle: 'Удаление',
      deleteBody: 'Удаление «{{word}}» пока не подключено к бэку.',
      applyTitle: 'Замена',
      applyBody: 'Заменить «{{from}}» на «{{to}}» — пока не подключено к бэку.',
    },
  },
  cram: {
    kicker: 'Тренировка',
    loadError: 'Не удалось загрузить тренировку.',
    retry: 'Попробовать снова',
    noCards: 'Добавь готовые карточки в модуль, чтобы начать тренировку.',
    resumeTitle: 'Тренировка сохранена',
    resumeFinal: 'Остался финальный матч — собери слова в пары.',
    resumeRemaining: 'Осталось карточек: {{count}}. Продолжи с того места, где остановился.',
    resume: 'Продолжить тренировку',
    changeSetup: 'Собрать новую тренировку',
    replaceNote: 'Запуск новой тренировки заменит сохранённую сессию этого модуля.',
    title: 'Что прогоняем?',
    intro:
      'Выбери упражнения и карточки для этой тренировки.',
    note: 'Тренируйся в своём темпе. Сессию можно завершить досрочно.',
    startError: 'Не удалось начать практику. Попробуй ещё раз.',
    wip: 'В разработке',
    builder: {
      back: 'к модулю',
      starting: 'Запускаем…',
      title: 'Тренировка под тебя',
      sub: 'Выбери готовый сценарий или собери свой. Всё готово — можно начинать.',
      filters: {
        label: 'Фильтр карточек',
        // Сначала с ошибками и давно не встречавшиеся, потом новые (по истории тренировок, 2026-10-21).
        today: 'На сегодня',
        all: 'Все карточки',
        mistakes: 'С ошибками',
        frequent: 'Чаще ошибаюсь',
        manual: 'Выбрано вручную',
        mistakesHint: 'Карточки с неверными ответами в тренировках этого модуля. Исправленные ошибки тоже учитываются.',
        frequentHint: 'В подборку первыми попадут карточки с наибольшим числом ошибок. Выбери, сколько взять.',
        loading: 'Загружаем историю ошибок…',
        loadError: 'Не удалось загрузить историю ошибок.',
        emptyTitle: 'Пока нет карточек с ошибками',
        emptyBody: 'После неверных ответов в тренировках карточки появятся здесь.',
        showAll: 'Взять все карточки',
      },
      setup: {
        format: 'Как тренируемся',
        formats: 'Форматы',
        cardsShort: 'Карточки',
        pickedOf: 'выбрано {{count}} из 4',
        nonePicked: 'ничего не выбрано',
        manualNote:
          'Карточки, созданные вручную, попадут только в прямой и обратный перевод (без подсказки) и в выбор слова: у них нет сгенерированного ИИ контекста, подсказки и описания значения.',
        finalMatch: 'Финальный матч',
        finalMatchDesc: 'в конце — собрать все слова в пары',
        finalMatchOff: 'без финального матча',
        previewLabel: 'Так выглядит упражнение',
        manualShort: 'Вручную',
        cards: 'Какие карточки возьмём',
        restore: 'Как в прошлый раз',
        customize: 'Настроить упражнения',
        customizeHint: 'Выбрать форматы упражнений',
        expand: 'Открыть',
        collapse: 'Скрыть',
        exerciseCount_one: '{{count}} формат',
        exerciseCount_few: '{{count}} формата',
        exerciseCount_many: '{{count}} форматов',
        exerciseHelp: 'Выбери один или несколько форматов. Упражнения будут идти в случайном порядке.',
        availability: 'Контексту нужен пример, выбору ответа — варианты. Если их нет, карточка получит другой доступный формат.',
        amount: 'Количество карточек',
        all: 'Все',
        allCards: 'Все карточки модуля · {{count}}',
        available: 'В модуле: {{count}}',
        chooseCards: 'Выбрать вручную',
        shuffleCards: 'Другие карточки',
        selectedCards: 'Выбранные карточки',
        showAllSelected: 'Посмотреть все выбранные карточки',
        limit: 'За одну тренировку — до {{count}} карточек. Можно выбрать нужные вручную.',
        summary: 'Твоя тренировка',
        distributionNote: 'По одному формату на карточку. Выбранные упражнения идут в случайном порядке.',
        flowPractice: 'Практика в своём темпе',
        flowRepeat: 'Повтор ошибок, если они будут',
        flowMatch: 'Финальный матч на пары',
        saveNote: 'Запомним этот состав после запуска.',
        presets: {
          warmup: { title: 'Разминка', short: 'Разминка', desc: 'Узнавай слова и переводи на русский.', caption: 'Выбор ответа + перевод' },
          balanced: { title: 'Все упражнения', short: 'Всё', desc: 'Практикуй слова с разных сторон.', caption: 'Все 4 формата' },
          challenge: { title: 'Вызов', short: 'Вызов', desc: 'Вспоминай и вписывай английские слова.', caption: 'Обратный перевод + контекст' },
          custom: { title: 'Свой набор', short: 'Своя' },
        },
      },
      ex: {
        input: {
          title: 'Прямой перевод',
          desc: 'видишь слово — вводишь перевод',
          pair: 'EN → RU',
          rule: 'Простое предложение, слово в нём выделено — переведи его на русский. У ручных карточек — просто слово. Опечатка в одной букве и синоним засчитываются, перевод другого значения слова — тоже, с пометкой.',
        },
        reverse: {
          title: 'Обратный перевод',
          desc: 'видишь перевод — вводишь слово',
          pair: 'RU → EN',
          rule: 'Перевод крупно, слово скрыто. Подсказка открывает первую букву — объяснения здесь нет.',
        },
        mcq: {
          title: 'Выбор слова',
          desc: 'выбираешь верный из вариантов',
          pair: '4 варианта',
          rule: 'Четыре варианта, клавиши 1–4. «Не помню» здесь не нужно — ответ и так на экране. Ошибка подсвечивает верный вариант.',
        },
        cloze: {
          title: 'Пропущено слово',
          desc: 'вставляешь слово в предложение',
          pair: 'контекст',
          rule: 'Пример с пропуском. Ответ — по-английски. Подсказка: первая буква и значение. После ответа раскрывается только значение — пример уже был вопросом.',
        },
      },
      preview: {
        label: 'состав сессии',
        cardsNoun_one: 'карточка',
        cardsNoun_few: 'карточки',
        cardsNoun_many: 'карточек',
        even: 'поровну по типам',
        single: 'вся сессия из одного типа',
        random: 'случайный порядок',
        randomLegend: 'случайно из всех 4 типов',
      },
      empty: 'Выбери хотя бы одно упражнение.',
      emptyCards: 'Выбери хотя бы одну карточку.',
      start: 'Начать тренировку',
      startHint: 'Выбери упражнения',
      loading: 'Загружаем настройки…',
      compose: {
        title: 'Состав карточек',
        all_one: 'все {{count}} карточка модуля',
        all_few: 'все {{count}} карточки модуля',
        all_many: 'все {{count}} карточек модуля',
        none: 'ни одной — выбери карточки',
        subset: '{{n}} из {{total}} карточек',
        change: 'Изменить',
      },
      picker: {
        title: 'Состав сессии',
        sub: 'Выбери до {{max}} карточек. Изменения сохранятся после нажатия «Применить».',
        cancel: 'Отмена',
        apply: 'Применить',
        selectVisible: 'Выбрать найденные',
        limit: 'Можно выбрать до {{max}} карточек за сессию.',
        limitReached: 'Выбрано {{max}} карточек. Сними одну, чтобы добавить другую.',
        selectAtLeastOne: 'Выбери хотя бы одну карточку.',
        presetUpTo: 'Первые {{n}}',
        mistakes: 'Ошибок: {{count}}',
        close: 'закрыть',
        search: 'поиск по слову или переводу…',
        presetAll: 'Выбрать все',
        presetFirst: 'Первые {{n}}',
        presetLast: 'Последние {{n}}',
        presetNone: 'Снять все',
        empty: 'Ничего не нашлось',
        ofTotal: 'из {{total}} выбрано',
        done: 'Готово',
      },
    },
  },
  session: {
    // Серия — дни подряд (как «1-й день серии» на итоге знакомства); верные ответы подряд — «подряд».
    streak_one: 'день серии',
    streak_few: 'дня серии',
    streak_many: 'дней серии',
    streak_other: 'дня серии',
    comboRun: '{{count}} подряд',
    exitShort: 'выйти',
    finishShort: 'завершить',
    // «Завершить» вторым нажатием (ТЗ демо 1.6): подпись после первого.
    finishConfirm: 'завершить?',
    // С 2026-10-21 — окно подтверждения (решение владельца: второе нажатие никто не замечал).
    finishDialogTitle: 'Завершить тренировку?',
    finishDialogBody: 'Ответы сохранятся, но продолжить эту тренировку будет нельзя.',
    finishDialogYes: 'Завершить',
    finishDialogNo: 'Продолжить',
    finishing: 'Завершаем…',
    finishError: 'Не удалось завершить тренировку. Попробуй ещё раз.',
    // Ответ не отправлен (categorizeAnswerError, B13): строка над сценой.
    answerError: {
      network: 'Нет связи — ответ не отправлен. Отправь его ещё раз, когда сеть вернётся.',
      reconnected: 'Связь вернулась — отправь ответ ещё раз.',
      server: 'Сервер не принял ответ. Попробуй ещё раз.',
      unknown: 'Не удалось отправить ответ. Попробуй ещё раз.',
      desync: 'Тренировка изменилась в другой вкладке — загружаем заново…',
      tooLong: 'Слишком длинный ответ — введи слово или короткую фразу.',
      rateLimited: 'Слишком быстро. Подожди {{n}}\u00a0с и попробуй снова.',
      rateLimitedShort: 'Слишком быстро. Подожди немного.',
      checkUnavailable: 'Проверка ответа ненадолго недоступна. Отправь ещё раз через пару секунд.',
    },
    completeError: 'Не удалось сохранить результаты. Повтори сохранение.',
    retryComplete: 'Сохранить результаты',
    loading: 'Загружаем сессию…',
    emptyTitle: 'Тренировка не найдена',
    emptySub: 'Выбери модуль и начни новую тренировку.',
    errorTitle: 'Не удалось загрузить сессию',
    exit: 'Выход',
    progressTitle: 'карточка {{current}} из {{total}}',
    manualNote: {
      title: 'Карточка добавлена вручную',
      body: 'Без AI у неё нет подсказки, примера в предложении и простого предложения для перевода — поэтому упражнения только со словом.',
    },
    task: {
      input: 'переведи на русский',
      // Вопрос — предложение с выделенным словом: переводят только его (владелец 2026-10-29).
      inputWord: 'переведи выделенное слово',
      reverse: 'вспомни слово по-английски',
      mcq: 'выбери перевод',
      cloze: 'заполни пропуск',
    },
    typeTranslation: 'перевод…',
    // Коротко: на 320 px длинная подсказка обрезается, а «выделенное» уже сказано в задании.
    typeTranslationWord: 'перевод слова…',
    typeWordEn: 'слово по-английски…',
    checkBtn: 'Проверить',
    // Вердикт задержался дольше 1,2 с (смысловая проверка), ТЗ демо 1.7.
    checkingLong: 'Проверяем ответ…',
    dontKnow: 'не помню',
    hint: {
      show: 'подсказка',
      firstLetter: 'первая буква',
      startsWith: 'начинается на «{{letter}}»',
    },
    legend: {
      typed: 'Enter — проверить · Tab — подсказка · Esc — не помню',
      reverse: 'Enter — проверить · Tab — первая буква · Esc — не помню',
      mcq: '1–4 — выбрать · Tab — подсказка',
    },
    verdict: {
      ok: 'верно',
      typo: 'верно, с опечаткой',
      semantic: 'верно, по смыслу',
      gaveUp: 'не помню · вернётся позже',
      wrong: 'неверно · вернётся позже',
    },
    feedback: {
      continue: 'Продолжить',
      correctIs: 'правильно',
      offSense: 'Похоже, ты учишь другое значение:',
      contextNote: 'Засчитано, но в этом предложении {{word}} — «{{expected}}», а не «{{matched}}»',
      contextNoteShort: 'Засчитано, но в этом предложении {{word}} — «{{expected}}»',
      // Перевели всю фразу вместо слова — засчитано, но переводить нужно только выделенное.
      wholeSentence: 'Засчитано! Здесь достаточно перевести только выделенное слово: {{word}}\u00a0— «{{expected}}»',
    },
    boss: {
      eyebrow: 'финальный раунд',
      title: 'Соедини пары',
      intro_one: '{{count}} слово из тренировки. Соедини его с переводом — так быстро, как сможешь.',
      intro_few: '{{count}} слова из тренировки. Соедини каждое с переводом — так быстро, как сможешь.',
      intro_many: '{{count}} слов из тренировки. Соедини каждое с переводом — так быстро, как сможешь.',
      step1: 'слово слева',
      step2: 'перевод справа',
      step3: 'пара исчезает',
      start: 'Начать',
      taskLeft: 'выбери слово слева',
      taskRight: 'теперь — перевод справа',
      hit: 'есть пара',
      missed: 'не то — попробуй ещё',
      allDone: 'готово — все пары собраны',
      foot: 'клик по слову, затем по переводу · промах не штрафуется, но ломает чистый раунд',
    },
    complete: {
      kicker: 'тренировка завершена',
      minutes: '{{count}} мин',
      headlineClean: 'Чисто.',
      headlineGood: 'Хорошая работа.',
      headlineWork: 'Есть над чем поработать.',
      subReturn_one: '{{count}} слово вернётся в следующую тренировку',
      subReturn_few: '{{count}} слова вернутся в следующую тренировку',
      subReturn_many: '{{count}} слов вернутся в следующую тренировку',
      subPerfect: 'все слова с первого раза — так и держи',
      accuracy: 'точность',
      // Подписи плиток под числом — в именительном, чтобы не выходило «2 ошибок» (как на лендинге).
      answers: 'ответы',
      wrong: 'ошибки',
      bestRun: 'лучшая серия',
      bossLine: 'финальный раунд: {{clean}} из {{total}} без промахов · {{seconds}} с',
      mistakes: 'были ошибки',
      mistakesTitle_one: '{{count}} слово с ошибкой',
      mistakesTitle_few: '{{count}} слова с ошибками',
      mistakesTitle_many: '{{count}} слов с ошибками',
      showAll: 'Посмотреть все · {{count}}',
      done: 'Готово',
    },
  },
  stats: {
    title: 'Статистика',
    sub: 'Прогресс за всё время обучения.',
    kpis: {
      total: { k: 'Всего слов', v: '847', s: 'B2 · 68% покрытия' },
      avg: { k: 'Средняя точность', v: '92%', s: 'по 7280 ответам' },
      hours: { k: 'Часов обучения', v: '34.2', s: '≈ 12 минут в день' },
    },
    activity: 'Активность · 26 недель',
    byType: 'По типам упражнений',
    hardWords: 'Топ трудных слов',
    wrongCount_one: '{{count}} ошибка',
    wrongCount_few: '{{count}} ошибки',
    wrongCount_many: '{{count}} ошибок',
  },
  profile: {
    title: 'Настройки',
    sub: 'Профиль, язык интерфейса и настройки тренировки.',
    save: 'Сохранить',
    saving: 'Сохраняем…',
    saved: 'Настройки сохранены',
    saveError: 'Не удалось сохранить. Попробуй ещё раз.',
    signOut: 'Выйти из аккаунта',
    rows: {
      name: { k: 'Имя', h: 'Отображается в профиле' },
      autoAdvance: { k: 'Автопереход', h: 'Сам переходить к следующей карточке после верного ответа. По умолчанию выключено — переход по «Продолжить» или Enter.' },
      reminders: {
        k: 'Напоминания на почту',
        h: 'Короткое письмо, если давно не занимался: в первую неделю — до 4 писем, дальше не чаще раза в неделю.',
        unverified: 'Письма приходят на подтверждённую почту.',
        // Переключатель сохраняется сразу (ТЗ демо 1.10).
        saved: 'Сохранено',
        saveError: 'Не сохранилось — попробуй ещё раз',
      },
      lang: { k: 'Язык интерфейса', h: 'Язык меню и подсказок' },
    },
  },
  unsubscribe: {
    kicker: 'Напоминания',
    pending: 'Отключаем напоминания…',
    saving: 'Сохраняем…',
    off: {
      title: 'Готово',
      body: 'Напоминания на почту больше не придут. Включить их снова можно здесь или в настройках.',
    },
    on: {
      title: 'Напоминания включены',
      body: 'Пришлём короткое письмо, если давно не занимался.',
    },
    resubscribe: 'Вернуть напоминания',
    unsubscribeAgain: 'Отписаться',
    open: 'Открыть Lomora',
    toggleError: 'Не получилось сохранить. Попробуй ещё раз.',
    invalid: {
      title: 'Ссылка не сработала',
      body: 'Она устарела или скопировалась не целиком. Отключить напоминания можно в настройках.',
      settings: 'Открыть настройки',
    },
    error: {
      title: 'Не получилось отключить',
      body: 'Сервер не ответил. Попробуй ещё раз.',
      rateLimit: 'Слишком много попыток. Подожди минуту и попробуй ещё раз.',
      retry: 'Попробовать ещё раз',
    },
  },
  stub: {
    placeholder: 'Скоро здесь будет {{title}}',
    sub: 'Этот раздел появится в следующих шагах. Сейчас доступны только Auth → Onboarding → Главная.',
  },
  user: {
    me: {
      name: 'Алекс Петров',
      email: 'alex@example.com',
    },
  },
  plans: {
    title: 'Тарифы',
    sub: 'Жетоны тратятся только на карточки, которые готовит AI. Ручные карточки всегда бесплатны и без ограничений.',
    free: 'Бесплатно',
    perMonth: '{{price}} ₽ / мес',
    perDayLabel: 'жетонов в день',
    current: 'Текущий тариф',
    choose: 'Перейти',
    pay: 'Оформить',
    switch: 'Перейти',
    extend: 'Продлить',
    payPending: 'Создаём платёж…',
    payNote: 'Разовая оплата · доступ на 30 дней',
    onSwitch: 'разово при переходе',
    payErrorTitle: 'Не удалось начать оплату',
    payErrorMessage: 'Попробуй ещё раз через минуту.',
    loadError: 'Не удалось загрузить тарифы. Обнови страницу.',
    usageToday: 'Сегодня использовано {{used}} из {{limit}}',
    soonTitle: 'Оплата скоро',
    soonMessage: 'Подключаем приём платежей — подписка появится здесь совсем скоро.',
    tagline: {
      DEMO: 'Старт без вложений',
      PRO: 'Для регулярной практики',
      PREMIUM: 'Максимальный темп',
    },
    moreWords: 'В {{x}} раз больше новых слов с полным разбором каждый день',
    donateTitle: 'Поддержать проект',
    donateSub: 'Разовый донат помогает развивать Lomora и держать AI-генерацию доступной для всех.',
    donateCta: 'Поддержать',
    donateCtaAmount: 'Поддержать на {{amount}} ₽',
    donateCustom: 'Своя сумма',
    donateMin: 'Минимальная сумма — {{min}} ₽',
  },
  billing: {
    title: 'Тарифы',
    // Страница «Тарифы» по макетам «Страница тарифов» / «Тарифы мобайл».
    shop: {
      close: 'Закрыть',
      loading: 'Загружаем тарифы',
      retry: 'Попробовать снова',
      hero: {
        demo: 'Учи нужные слова.',
        demoEm: 'В своём темпе.',
        pro: 'У тебя Pro.',
        proEm: 'Нужно больше жетонов?',
        max: 'У тебя Max.',
        maxEm: 'Максимум жетонов.',
      },
      status: {
        label: 'Твой доступ',
        demoFree: 'бесплатно',
        demoTitle: 'Без срока',
        demoNote_one: '{{count}} жетон каждый день · ручные карточки без лимита',
        demoNote_few: '{{count}} жетона каждый день · ручные карточки без лимита',
        demoNote_many: '{{count}} жетонов каждый день · ручные карточки без лимита',
        demoNote_other: '{{count}} жетона каждый день · ручные карточки без лимита',
        paidOn: 'оплачен {{date}}',
        daysLeft_one: 'Остался {{count}} день',
        daysLeft_few: 'Осталось {{count}} дня',
        daysLeft_many: 'Осталось {{count}} дней',
        daysLeft_other: 'Осталось {{count}} дня',
        paidUntil: 'до {{date}} · без автопродления',
        quota: 'Осталось жетонов',
        quotaShort: 'Жетоны',
        resets: 'обновится в {{time}} МСК',
        exhausted: 'жетоны закончились · новые в {{time}} МСК',
        exhaustedBonus: 'дневные закончились · тратятся несгораемые, новые дневные в {{time}} МСК',
        // Несгораемые жетоны (2026-10-22): не сгорают в полночь, тратятся, когда дневные закончились.
        bonus_one: '+ {{count}} несгораемый жетон',
        bonus_few: '+ {{count}} несгораемых жетона',
        bonus_many: '+ {{count}} несгораемых жетонов',
        bonus_other: '+ {{count}} несгораемых жетона',
      },
      features: {
        practice: 'Учить созданные карточки',
        practiceText: 'Тренировки по своим карточкам и модулям.',
        create: 'Создавать карточки и модули',
        createText: 'Вручную — без лимита.',
        ai: 'AI-генерация карточек',
        aiText: 'Перевод, пример и варианты за одно нажатие. Ручные и готовые карточки жетонов не тратят.',
        open: 'доступно',
        perDay: '{{count}} в день',
      },
      checkout: {
        choose: 'Выбери тариф',
        upgrade: 'Перейти на Max',
        yours: 'Твой тариф',
        daily_one: '{{count}} жетон в день',
        daily_few: '{{count}} жетона в день',
        daily_many: '{{count}} жетонов в день',
        daily_other: '{{count}} жетона в день',
        allOfPro: 'всё из Pro',
        currentUntil: 'текущий · до {{date}}',
        upgradeTag: 'доплата за оставшиеся дни',
        afterDate: 'можно выбрать после {{date}}',
        period: 'Период',
        periodValue_one: '{{count}} день с момента оплаты',
        periodValue_few: '{{count}} дня с момента оплаты',
        periodValue_many: '{{count}} дней с момента оплаты',
        periodValue_other: '{{count}} дня с момента оплаты',
        autoRenew: 'Автопродление',
        no: 'нет',
        daysLeft: 'Осталось дней',
        ends: 'Окончание',
        endsSame: '{{date}} — не меняется',
        validUntil: 'Действует до',
        nextPeriod: 'Следующий период',
        afterEnd: 'после окончания',
        total: 'Итого',
        topUp: 'Доплата',
        pay: 'Оплатить {{amount}}',
        payPlan: 'Оплатить {{plan}}',
        upgradePay: 'Доплатить {{amount}}',
        upgradeShort: 'Перейти на Max',
        newPeriod: 'Новый период — после {{date}}',
        footBuy: 'Срок начнётся сразу после оплаты · ЮKassa, карта не сохраняется',
        footBuyShort: 'Срок начнётся сразу после оплаты · ЮKassa',
        footUpgrade_one: '{{count}} жетон добавится сразу · продлить Pro можно после {{date}}',
        footUpgrade_few: '{{count}} жетона добавятся сразу · продлить Pro можно после {{date}}',
        footUpgrade_many: '{{count}} жетонов добавятся сразу · продлить Pro можно после {{date}}',
        footUpgrade_other: '{{count}} жетона добавятся сразу · продлить Pro можно после {{date}}',
        footUpgradeShort_one: '{{count}} жетон добавится сразу',
        footUpgradeShort_few: '{{count}} жетона добавятся сразу',
        footUpgradeShort_many: '{{count}} жетонов добавятся сразу',
        footUpgradeShort_other: '{{count}} жетона добавятся сразу',
        footCurrent: 'Ручные карточки жетонов не тратят — их можно добавлять и сейчас',
        footCurrentShort: 'Ручные карточки можно добавлять и сейчас',
      },
      donate: {
        title: 'Поддержать',
        note: 'разово, не меняет тариф',
        noteShort: 'не меняет тариф',
        custom: 'своя',
        placeholder: 'Своя сумма',
        enter: 'Введи сумму',
        min: 'Минимум {{amount}}',
        cta: 'Поддержать на {{amount}}',
      },
      details: {
        faq: 'Вопросы об оплате',
        history: 'История оплат',
      },
      faq: {
        autoRenew: {
          q: 'Будет ли автосписание?',
          a_one: 'Нет. Тариф покупается разовым платежом на {{count}} день. Когда срок закончится, можно просто купить новый период.',
          a_few: 'Нет. Тариф покупается разовым платежом на {{count}} дня. Когда срок закончится, можно просто купить новый период.',
          a_many: 'Нет. Тариф покупается разовым платежом на {{count}} дней. Когда срок закончится, можно просто купить новый период.',
          a_other: 'Нет. Тариф покупается разовым платежом на {{count}} дня. Когда срок закончится, можно просто купить новый период.',
        },
        start: {
          q: 'Когда начинается срок тарифа?',
          a: 'В момент оплаты. Например, оплата {{start}} — тариф действует до {{end}}.',
        },
        spend: {
          q: 'Что такое жетоны?',
          a: 'Каждый день в полночь по Москве начисляются жетоны — сколько, зависит от тарифа. Жетон тратится, когда AI готовит карточки: одно нажатие «Создать» — один жетон, до 10 значений за раз. Подборка слов по теме: 10 слов — один жетон, 20 — два. Если подготовить карточки не получилось, жетон вернётся. Неиспользованные жетоны на завтра не переносятся. Ручные карточки, готовые модули и тренировки жетонов не тратят.',
        },
        reset: {
          q: 'Когда приходят новые жетоны?',
          a: 'Каждый день в {{time}} по Москве.',
        },
        upgrade: {
          q: 'Как перейти с Pro на Max?',
          a: 'В любой момент текущего периода. Платишь только разницу цен за оставшиеся дни, дата окончания не меняется.',
        },
        early: {
          q: 'Можно продлить заранее или перейти с Max на Pro?',
          a: 'Нет. Новый период, как и переход на Pro, доступен после окончания текущего.',
        },
        afterDemo: {
          q: 'Что будет после окончания Demo?',
          a: 'Создание и AI-генерация карточек закроются. Учить уже созданные карточки можно дальше.',
        },
        payment: {
          q: 'Как проходит оплата?',
          a: 'Через ЮKassa. Данные карты Lomora не получает и не сохраняет.',
        },
      },
      history: {
        date: 'Дата',
        what: 'Что',
        sum: 'Сумма',
        status: 'Статус',
        item_one: '{{plan}} · {{count}} день',
        item_few: '{{plan}} · {{count}} дня',
        item_many: '{{plan}} · {{count}} дней',
        item_other: '{{plan}} · {{count}} дня',
        upgrade: 'Доплата: {{from}} → {{plan}}',
        until: 'до {{date}}',
        donation: 'Поддержка Lomora',
        donationNote: 'донат',
        paid: 'оплачено',
        free: 'бесплатно',
        receipts: 'Чеки приходят на почту после каждой оплаты.',
        empty: 'Оплат пока не было',
        emptyText: 'Здесь появятся покупки тарифов и донаты.',
      },
      legalPrefix: 'Продолжая оплату, ты принимаешь',
      legalLink: 'оферту',
    },
    sub: 'Доступ оплачивается периодами по 31 дню с даты покупки. Жетоны нужны только для карточек, которые готовит AI; ручные карточки всегда бесплатны.',
    loadError: 'Не удалось загрузить тарифы. Обнови страницу.',
    pendingOtherTierTitle: 'Незавершённый платёж',
    pendingOtherTierMessage: 'У тебя уже есть незавершённый платёж на {{tier}}. Заверши его или дождись отмены, прежде чем выбрать другой тариф.',
    mobile: {
      intro: 'Доступ оплачивается периодами по 31 дню с даты покупки. Жетоны нужны только для карточек от AI.',
      sectionPlans: 'Тарифы',
    },
    card: {
      free: 'Бесплатно',
      perPeriod: '/ период',
      perDay: 'жетонов',
      perDay2: 'в день',
      moreWords: 'В {{x}} раз больше новых слов, чем на Demo',
      accessDays: 'доступ на {{count}} дней',
      accessDays_one: 'доступ на {{count}} день',
      accessDays_few: 'доступ на {{count}} дня',
      accessDays_many: 'доступ на {{count}} дней',
      // Каждая кнопка говорит, за что и на какие даты платёж (табов периода нет).
      buy: 'Оформить {{plan}}',
      buySub: '{{count}} дней доступа с момента оплаты',
      buySub_one: '{{count}} день доступа с момента оплаты',
      buySub_few: '{{count}} дня доступа с момента оплаты',
      buySub_many: '{{count}} дней доступа с момента оплаты',
      upgradeNow: 'Перейти на Max · +{{amount}} ₽',
      upgradeNowSub: 'доплата за остаток периода · до {{date}}',
      currentUntil: 'Используется · до {{date}}',
      lockedByMax: 'Недоступен, пока действует Max',
      alwaysIncluded: 'Включён всегда — даже на платных тарифах',
      feats: {
        ai: 'AI сам делает карточку из слова',
        manual: 'Свои карточки вручную — без лимита',
        modes: 'Тренировки и ознакомление',
        exercises: 'Выбор упражнений для тренировки',
        check: 'Опечатки не считаются ошибкой',
        noAuto: 'Разовая оплата — без автосписаний',
      },
      unavailable: 'Недоступно',
      yourPlan: 'Ваш текущий тариф · до {{date}}',
      upgradeBadge: 'апгрейд',
      popularBadge: 'популярный',
    },
    breakdown: {
      toggle: 'Почему {{pay}} ₽, а не {{full}} ₽?',
      fullPrice: 'Полная цена Max',
      credit: 'Зачёт остатка Pro · {{count}} дн.',
      credit_one: 'Зачёт остатка Pro · {{count}} день',
      credit_few: 'Зачёт остатка Pro · {{count}} дня',
      credit_many: 'Зачёт остатка Pro · {{count}} дней',
      payToday: 'К оплате сегодня',
      note: 'Зачитываем неиспользованные дни Pro в текущем периоде. Чем ближе к концу периода — тем меньше зачёт и дороже переход.',
    },
    trust: {
      gateway: 'Оплата через сертифицированный шлюз',
      methods: 'Мир · Visa · Mastercard · СБП',
      receipt: 'Без автосписаний',
    },
    history: {
      heading: 'История',
      count: '{{count}} периодов',
      count_one: '{{count}} период',
      count_few: '{{count}} периода',
      count_many: '{{count}} периодов',
      empty: 'Пока нет оплаченных периодов.',
      paid: 'Оплачено · {{amount}} ₽',
    },
    legal:
      'Оплачивая счёт, ты соглашаешься с условиями оферты.',
  },
  // «Задание дня» на главной (2026-10-22): 5 новых слов каталога → тренировка → несгораемые жетоны.
  dailyTask: {
    kicker: 'Задание дня',
    title_one: '{{count}} новое слово',
    title_few: '{{count}} новых слова',
    title_many: '{{count}} новых слов',
    title_other: '{{count}} новых слова',
    text: 'Слова из готовых модулей Lomora, которых у тебя ещё нет: познакомься с ними и выучи в тренировке.',
    reward_one: '+{{count}} жетон',
    reward_few: '+{{count}} жетона',
    reward_many: '+{{count}} жетонов',
    reward_other: '+{{count}} жетона',
    take: 'Получить слова',
    taking: 'Подбираем слова…',
    learn: 'Учить слова',
    starting: 'Запускаем тренировку…',
    learnNote: 'Упражнения выберет Lomora, финального матча нет. Доведи тренировку до конца — и жетоны твои.',
    intro_one: 'Познакомься со словами, потом выучи их в тренировке. За выполнение — {{count}} несгораемый жетон.',
    intro_few: 'Познакомься со словами, потом выучи их в тренировке. За выполнение — {{count}} несгораемых жетона.',
    intro_many: 'Познакомься со словами, потом выучи их в тренировке. За выполнение — {{count}} несгораемых жетонов.',
    intro_other: 'Познакомься со словами, потом выучи их в тренировке. За выполнение — {{count}} несгораемых жетона.',
    doneTitle: 'Задание выполнено',
    doneText: 'Новое задание — завтра',
    emptyTitle: 'Новых слов пока нет',
    emptyText: 'Ты уже учишь все слова из готовых модулей Lomora. Загляни завтра.',
    toModule: 'Открыть модуль',
    back: 'На главную',
    startError: 'Не удалось получить слова. Попробуй ещё раз.',
    trainError: 'Не удалось запустить тренировку. Попробуй ещё раз.',
    loadError: 'Не удалось загрузить задание.',
    retry: 'Повторить',
  },
  // Начисления несгораемых жетонов за тренировку — тосты (2026-10-22).
  rewards: {
    streak: {
      title: 'Серия продолжается — день {{streak}}',
      text_one: '+{{count}} несгораемый жетон за серию.',
      text_few: '+{{count}} несгораемых жетона за серию.',
      text_many: '+{{count}} несгораемых жетонов за серию.',
      text_other: '+{{count}} несгораемых жетона за серию.',
    },
    comeback: {
      title: 'С возвращением!',
      text_one: '+{{count}} несгораемый жетон, чтобы продолжить.',
      text_few: '+{{count}} несгораемых жетона, чтобы продолжить.',
      text_many: '+{{count}} несгораемых жетонов, чтобы продолжить.',
      text_other: '+{{count}} несгораемых жетона, чтобы продолжить.',
    },
    daily_task: {
      title: 'Задание дня выполнено',
      text_one: '+{{count}} несгораемый жетон на балансе.',
      text_few: '+{{count}} несгораемых жетона на балансе.',
      text_many: '+{{count}} несгораемых жетонов на балансе.',
      text_other: '+{{count}} несгораемых жетона на балансе.',
    },
    // Подпись к крупному «+2» у выполненных «Задания дня» и «Миссии дня» (RewardBadge, 2026-10-22).
    earned_one: 'жетон получен',
    earned_few: 'жетона получено',
    earned_many: 'жетонов получено',
    earned_other: 'жетона получено',
  },
  subscription: {
    title: 'Подписка',
    // Тариф Demo (ТЗ демо 1.9): «Бесплатный тариф» убран — одно состояние одним именем, как на «Тарифах».
    demo: {
      title: 'Demo',
      // Demo бесплатно и без срока с 2026-10-22.
      free_one: 'Бесплатно и без срока: {{count}} жетон в день. На Pro и Max жетонов больше.',
      free_few: 'Бесплатно и без срока: {{count}} жетона в день. На Pro и Max жетонов больше.',
      free_many: 'Бесплатно и без срока: {{count}} жетонов в день. На Pro и Max жетонов больше.',
      free_other: 'Бесплатно и без срока: {{count}} жетона в день. На Pro и Max жетонов больше.',
      bonus_one: 'И ещё {{count}} несгораемый жетон.',
      bonus_few: 'И ещё {{count}} несгораемых жетона.',
      bonus_many: 'И ещё {{count}} несгораемых жетонов.',
      bonus_other: 'И ещё {{count}} несгораемых жетона.',
    },
    choosePlan: 'Выбрать тариф',
    activeChip: 'Активна',
    activeUntil: 'Активна до {{date}} · потом — бесплатный Demo',
  },
  payment: {
    pending: {
      title: 'Проверяем оплату',
      sub: 'Это займёт несколько секунд — не закрывай страницу.',
    },
    success: {
      title: 'Оплата прошла',
      sub: 'Тариф {{tier}} активирован — приятной учёбы!',
      cta: 'К тарифам',
      planRow: 'Тариф',
      amountRow: 'Оплачено',
      untilRow: 'Доступ до',
      note: 'Без автопродления — доступ активен до этой даты. Продлить можно вручную в любой момент.',
    },
    donation: {
      title: 'Спасибо за поддержку!',
      sub: 'Твой вклад помогает развивать Lomora. Мы это очень ценим ♥',
      cta: 'На главную',
    },
    canceled: {
      title: 'Платёж отменён',
      sub: 'Оплата не завершена. Можно попробовать ещё раз.',
      cta: 'Вернуться к тарифам',
    },
    error: {
      title: 'Не удалось проверить платёж',
      sub: 'Если деньги списались, всё применится в течение пары минут.',
      cta: 'К тарифам',
    },
  },
  quota: {
    // Баланс (2026-10-13): «Осталось 27 из 30», полоса — остаток.
    label: 'Осталось',
    outOf: 'из {{limit}}',
    balanceTitle: 'Осталось {{left}} из {{limit}} жетонов на сегодня. Новые — каждый день в полночь по Москве.',
    value: '{{used}} / {{limit}}',
    remaining: 'осталось {{remaining}}',
    used: '{{used}} из {{limit}}',
    usedTitle: 'Сегодня потрачено {{used}} из {{limit}} жетонов, осталось {{left}}. Новые жетоны — каждый день в полночь по Москве.',
    exhausted: 'Жетоны на сегодня закончились',
    resetAt: 'новые в {{time}}',
    // Несгораемые жетоны (2026-10-22): «+N» рядом с дневным балансом.
    bonus_one: '+{{count}} несгораемый',
    bonus_few: '+{{count}} несгораемых',
    bonus_many: '+{{count}} несгораемых',
    bonus_other: '+{{count}} несгораемых',
    bonusTitle_one: 'И ещё {{count}} несгораемый жетон — тратится, когда дневные закончились.',
    bonusTitle_few: 'И ещё {{count}} несгораемых жетона — тратятся, когда дневные закончились.',
    bonusTitle_many: 'И ещё {{count}} несгораемых жетонов — тратятся, когда дневные закончились.',
    bonusTitle_other: 'И ещё {{count}} несгораемых жетона — тратятся, когда дневные закончились.',
    bonusSpending: 'дневные закончились · тратятся несгораемые',
    upgrade: 'Перейти на тариф',
    reached:
      'Жетоны на сегодня закончились ({{used}}/{{limit}}). Новые придут в {{time}} — а пока можно создавать карточки вручную.',
  },
  admin: {
    // Две вкладки и аналитика учеников (решение владельца 2026-10-21).
    tabs: {
      label: 'Раздел админки',
      product: 'Аналитика',
      tech: 'Техника',
    },
    product: {
      since: 'считаем с {{date}}',
      notTracked: 'начнём считать после выката',
      tiles: {
        registered: 'Новых за {{days}} дн.',
        returned: 'Вернулись хотя бы раз',
        returnedSub: '{{n}} из {{base}} · без зарегистрированных сегодня',
        median: 'Первый возврат',
        medianValue: 'через {{n}} дн.',
        medianSub: 'медиана среди вернувшихся',
        events: 'Заходы и открытия страниц',
        eventsSub: 'с этого дня пишем в свой журнал',
        eventsNone: 'журнал начнётся после выката',
      },
      cohorts: {
        title: 'Удержание по неделям регистрации',
        hint: 'доля вернувшихся за 1, 3, 7, 14 и 30 дней; «—» — неделя ещё не дожила',
        week: 'Неделя',
        size: 'Новых',
        day: 'за {{n}} дн.',
      },
      buckets: {
        title: 'Через сколько возвращаются',
        hint: 'первый возврат новых за {{days}} дн., без сегодняшних',
        d1: 'На следующий день',
        d2_3: 'Через 2–3 дня',
        d4_7: 'Через 4–7 дней',
        d8_14: 'Через 8–14 дней',
        d15_30: 'Через 15–30 дней',
        d31: 'Позже месяца',
        never: 'Не вернулись',
      },
      funnel: {
        title: 'Воронка новых',
        hint: 'доля от зарегистрировавшихся за {{days}} дн.',
        registered: 'Зарегистрировались',
        onboarding: 'Прошли знакомство',
        verified: 'Подтвердили почту',
        card_tried: 'Попробовали создать карточку',
        card_created: 'Создали карточку',
        module_created: 'Создали свой модуль',
        words_added: 'Добавили слова в модуль',
        topics_opened: 'Открыли подбор слов',
        topic_batch: 'Сделали подборку',
        game_opened: 'Открыли игру',
        mission_finished: 'Прошли миссию дня',
        daily_task_taken: 'Взяли задание дня',
        returned: 'Вернулись в другой день',
        second_training_day: 'Тренировались в другой день',
        plans_opened: 'Открыли тарифы',
        payment_started: 'Начали оплату',
        paid: 'Оплатили',
      },
      features: {
        title: 'Функции',
        hint: 'за {{days}} дн.',
        people: 'Учеников',
        times: 'Раз',
        app_open: 'Заходили в приложение',
        card_presses: 'Нажимали «Создать»',
        topics_opened: 'Открывали подбор слов',
        topic_batches: 'Делали подборку',
        trainings_started: 'Начинали тренировку',
        trainings_completed: 'Заканчивали тренировку',
        library_added: 'Добавляли готовый модуль',
        plans_opened: 'Открывали тарифы',
        payments_started: 'Начинали оплату',
        paid: 'Оплатили',
      },
      emails: {
        title: 'Письма-напоминания',
        hint: 'за {{days}} дн. · «вернулись» — действие или заход за 3 суток после письма',
        empty: 'Писем за период не было: напоминания на проде пока выключены.',
        kind: 'Письмо',
        sent: 'Ушло',
        clicked: 'Кликнули',
        returned: 'Вернулись',
        trained: 'Тренировались',
        holdout: 'Контроль',
        holdoutHint: 'Кому письмо намеренно не отправили: сколько вернулись сами · сколько их',
        kinds: {
          onb_d1: 'Знакомство, день 1',
          onb_d2: 'Знакомство, день 2',
          onb_d4: 'Знакомство, день 4',
          onb_d7: 'Знакомство, день 7',
          weekly: 'Еженедельное',
          outreach: 'Личное письмо',
        },
      },
      modules: {
        title: 'Модули',
        hint: 'за {{days}} дн.',
        count: 'Штук',
        created: 'Создали свой модуль',
        added: 'Добавили готовый модуль',
        via: {
          library: 'из библиотеки',
          onboarding: 'при знакомстве, выбрали тему',
          onboarding_auto: 'при знакомстве, стартовый',
          share: 'по ссылке',
          other: 'раньше 19.10, без способа',
        },
        words: 'Добавили слова в модули',
        wordsOwn: 'в свои модули',
        wordsCopies: 'в копии готовых',
        deleted: 'Удалили модуль',
        top: 'Чаще всего добавляют из каталога',
        topEmpty: 'За период готовые модули не добавляли.',
      },
      metrika: {
        title: 'Откуда приходят · Яндекс Метрика',
        hint: 'за {{days}} дн. · {{visits}} визитов, {{users}} посетителей, {{registrations}} регистраций',
        off: 'Метрика не подключена: нет токена YANDEX_METRIKA_TOKEN.',
        error: 'Метрика сейчас не ответила — попробуй позже.',
        source: 'Источник',
        visits: 'Визиты',
        users: 'Посетители',
        registrations: 'Регистрации',
        conversion: 'Конверсия',
        noUtm: 'Визитов с utm-метками за период нет.',
      },
      users: {
        title: 'Новые ученики',
        onlyLost: 'только не вернувшиеся',
        count: '{{shown}} из {{total}} за {{days}} дн.',
        date: 'Дата',
        user: 'Ученик',
        source: 'Источник',
        onboarding: 'Знакомство',
        verified: 'Почта',
        presses: '«Создать»',
        modules: 'Модули',
        words: 'Слова',
        batches: 'Подборки',
        trainings: 'Тренировки',
        game: 'Игра',
        stories: 'Истории',
        missions: 'Миссия дня',
        boss: 'Граммозавр',
        bossHint: 'Боёв с Граммозавром: выиграно / начато',
        dailyTask: 'Задание дня',
        days: 'Дней',
        last: 'Последний',
        plan: 'Тариф',
      },
    },
    // Журнал ошибок бэкенда (2026-10-13): ERROR+ из API и воркеров, без ожидаемых отказов 4xx.
    errors: {
      title: 'Ошибки бэкенда',
      sub: 'Записи уровня ERROR из API и воркеров: ответы 5xx, падения задач, сбои внешних сервисов. Отказы пользователю — неверный пароль, занятая почта, просроченная ссылка — не считаются.',
      today: 'Ошибок сегодня',
      week: 'За 7 дней',
      month: 'За 30 дней',
      yesterday: 'вчера — {{n}}',
      prev: 'прошлые {{days}} дн. — {{n}}',
      notTracked: 'учёт начнётся после выкладки журнала ошибок',
      since: 'учёт с {{date}}',
      total: 'всего {{total}} за {{days}} дн.',
      chart: 'Ошибки по дням',
      series: 'Ошибки',
      places: 'Где падает',
      placesHint: 'за {{days}} дн., по числу ошибок',
      placesEmpty: 'За период ошибок не было.',
      recent: 'Последние ошибки',
      recentHint: 'новые сверху',
      recentEmpty: 'Ошибок пока не было.',
      showAll: 'Показать все · {{n}}',
      showLess: 'Свернуть',
      kibana: 'Открыть в Kibana',
      inKibana: 'в Kibana',
      last: 'последняя {{time}}',
      todayLink: 'ошибок сегодня: {{n}}',
      loadError: 'Не удалось загрузить журнал ошибок.',
    },
    analytics: {
      title: 'Аналитика',
      sub: 'Дни по Москве',
      periodLabel: 'Период',
      periodOption: '{{days}} дн.',
      period: 'за {{days}} дн.',
      activeHint: 'сделали действие: учились, создавали карточки, подборки',
      roundsHint: '{{words}} · подборок по теме: {{topics}}',
      spendHint: '{{total}} · в среднем {{avg}} в день',
      revenueHint: '{{total}} · успешные платежи',
      unitsNotTracked: 'учёт начнётся с первой генерации после выкладки',
      unitsSince: 'учёт с {{date}}',
      unitsTotal: 'всего {{total}}',
      kpi: {
        users: 'Пользователи',
        usersSub: 'сегодня +{{today}} · за {{days}} дн. +{{period}}',
        activeToday: 'Активны сегодня',
        activeSub: '7 дн. — {{week}} · 30 дн. — {{month}}',
        activePeriod: 'Активны за {{days}} дн.',
        ofUsers: '{{pct}} всех пользователей',
        paying: 'Платящие сейчас',
        payingSub: 'Pro {{pro}} · Max {{max}}',
        revenue: 'Выручка за {{days}} дн.',
        revenueSub: 'успешные платежи',
        units: 'AI-генерации сегодня',
        unitsSub: 'в среднем {{avg}} в день · всего {{total}}',
        spend: 'Расход на модель за {{days}} дн.',
        spendSub: 'сегодня {{today}} · прогноз на месяц {{month}}',
        margin: 'Выручка минус модель',
        marginSub: 'без комиссии, налога и сервера',
      },
      chart: {
        newUsers: 'Новые пользователи',
        active: 'Активные пользователи',
        units: 'AI-генерации из лимита',
        rounds: 'Генерации слов по кругам модели',
        spend: 'Расход на модель, ₽',
        revenue: 'Выручка, ₽',
        cards: 'Добавлено карточек',
        sessions: 'Тренировки',
      },
      series: {
        verified: 'подтвердили почту',
        unverified: 'не подтвердили',
        active: 'все активные',
        learners: 'учились',
        creators: 'создавали',
        units: 'единиц лимита',
        roundOne: 'с первого раза',
        roundTwo: '2-й круг',
        roundThree: '3-й круг и дальше',
        spend: 'расход',
        spendWords: 'слова и подборки',
        spendGame: 'игра',
        spendGrammar: 'грамматика',
        revenue: 'выручка',
        cardsAi: 'с AI',
        cardsManual: 'вручную',
        started: 'начаты',
        completed: 'завершены',
      },
      heatmap: {
        title: 'Генерации слов по пользователям',
        hint: 'учеников: {{count}} · за {{days}} дн.',
        empty: 'За период никто не генерировал слова и не играл.',
        total: 'за период',
        words_one: '{{count}} слово',
        words_few: '{{count}} слова',
        words_many: '{{count}} слов',
        words_other: '{{count}} слова',
        retry: 'повторы {{n}}',
        scale: 'слов за день',
        rounds: '2-й круг: {{two}} · 3-й и дальше: {{three}}',
        topics: 'подборок по теме: {{n}}',
        units: 'лимит: {{n}}',
        game_one: 'игра: {{count}} ход · {{rub}}',
        game_few: 'игра: {{count}} хода · {{rub}}',
        game_many: 'игра: {{count}} ходов · {{rub}}',
        game_other: 'игра: {{count}} хода · {{rub}}',
        grammar_one: 'грамматика: {{count}} проверка · {{rub}}',
        grammar_few: 'грамматика: {{count}} проверки · {{rub}}',
        grammar_many: 'грамматика: {{count}} проверок · {{rub}}',
        grammar_other: 'грамматика: {{count}} проверки · {{rub}}',
        played: 'были ходы игры',
        playedLegend: 'игра или грамматика (в слова не входят)',
      },
      plans: {
        title: 'Тарифы сейчас',
        hint: 'всего {{total}}',
      },
      funnel: {
        title: 'Воронка новых',
        registered: 'Зарегистрировались',
        verified: 'Подтвердили почту',
        firstCard: 'Добавили карточку',
        firstSession: 'Начали тренировку',
        paid: 'Оплатили',
      },
      health: {
        title: 'Удержание и качество',
        qualityTitle: 'Качество генерации',
        nextDay: 'Вернулись на следующий день',
        nextDayHint: 'из зарегистрированных за 30 дн.',
        week: 'Активны за последнюю неделю',
        weekHint: 'из пришедших 7+ дней назад',
        failed: 'Неудачные генерации',
        failedHint: 'карточки за {{days}} дн.',
        extra: 'Повторные вызовы модели',
        extraHint: 'доля вызовов сверх первого',
        topicFailed: 'Подборки не получились',
        topicFailedHint: 'за {{days}} дн., генерации вернулись',
      },
    },
    title: 'Расходы на генерацию',
    sub: 'Все пользователи и сколько стоят их генерации карточек в рублях. «Сегодня» — с 00:00 МСК, месяц — последние {{days}} дней.',
    generatedAt: 'Обновлено {{time}}',
    error: 'Не удалось загрузить дашборд. Обнови страницу.',
    noAccess: {
      title: 'Нет доступа',
      body: 'Раздел доступен только администраторам.',
    },
    measuredSince: 'Токены считаются с {{date}} · курс {{rate}} ₽/$',
    notMeasured: 'Токены ещё не записывались — траты появятся после первой генерации.',
    payments: 'Оплат без выданного периода: {{n}} на {{sum}}. Проверь вебхуки ЮKassa.',
    calls: {
      jobs_one: 'За {{days}} дн. — {{count}} генерация слов',
      jobs_few: 'За {{days}} дн. — {{count}} генерации слов',
      jobs_many: 'За {{days}} дн. — {{count}} генераций слов',
      one: '1 вызов модели — {{pct}}',
      two: '2 вызова — {{pct}}',
      threePlus: '3 и больше — {{pct}}',
      extra: 'на повторы — {{rub}} ({{pct}} трат на слова)',
      play: 'игра и грамматика — {{rub}} (в генерации не входят)',
    },
    table: {
      user: 'Пользователь',
      plan: 'Тариф',
      genToday: 'Ген. сегодня',
      genMonth: 'Ген. {{days}} дн.',
      rubToday: '₽ сегодня',
      rubAvgDay: '₽ в день',
      rubMonth: '₽ за {{days}} дн.',
      avgHint: 'Среднее: траты за {{days}} дн. ÷ {{days}}',
      extra: 'Повторы',
      extraCalls_one: '{{count}} вызов',
      extraCalls_few: '{{count}} вызова',
      extraCalls_many: '{{count}} вызовов',
      play: 'из них игра {{rub}}',
      playHint: 'Ходы игры и проверка грамматики: входят в рубли, но не в генерации',
      joined: 'Регистрация',
      total_one: 'Итого · {{count}} пользователь',
      total_few: 'Итого · {{count}} пользователя',
      total_many: 'Итого · {{count}} пользователей',
      admin: 'админ',
      emailNo: 'почта не подтверждена',
      empty: 'Пока нет пользователей.',
    },
  },
  // «Выживи в Лондоне» (2026-10-22): истории с ИИ-ведущим, миссия дня, босс из ошибок. Про ученика — без рода.
  stories: {
    hub: {
      kicker: 'Новое · игра',
      title: 'Выживи в Лондоне',
      sub: 'Говори с жителями Лондона по-английски — текстом или голосом. ИИ-ведущий каждый раз придумывает новый сюжет, а каждую ошибку разбирает по-русски.',
      mapLabel: 'Пиксельная карта Лондона: аэропорт Хитроу, вокзал Паддингтон, кафе, отель, Тауэр с боссом и закрытый офис второй главы',
      mapHint: 'Нажми на дом — герой дойдёт до него. Карту можно сдвинуть пальцем.',
      loadError: 'Не удалось загрузить игру. Обнови страницу.',
    },
    daily: {
      kicker: 'Миссия дня',
      character: 'Собеседник — {{name}}, до {{turns}} ответов',
      start: 'Начать миссию',
      startFree: 'Начать бесплатно',
      resume: 'Продолжить',
      viewResult: 'Итоги',
      again: 'Новая миссия — завтра в 00:00 по Москве',
      // Доп. цель миссии — доп. жетоны (владелец 2026-10-22); сейчас одна — «без ошибок» (три звезды).
      extraGoal_one: 'Доп. цель: без ошибок — ещё +{{count}} жетон',
      extraGoal_few: 'Доп. цель: без ошибок — ещё +{{count}} жетона',
      extraGoal_many: 'Доп. цель: без ошибок — ещё +{{count}} жетонов',
      extraGoal_other: 'Доп. цель: без ошибок — ещё +{{count}} жетона',
    },
    story: {
      kicker: 'История',
      goal: 'Цель: {{goal}}',
      play: 'Играть',
      resume: 'Продолжить',
      replay: 'Новый сюжет',
      best: 'Лучший результат',
      runs_one: '{{count}} прохождение',
      runs_few: '{{count}} прохождения',
      runs_many: '{{count}} прохождений',
      runs_other: '{{count}} прохождения',
      endings: 'Концовки',
      endingsCount: '{{n}} из {{total}}',
      secret: 'Секретная',
      stamps: 'Штампы в паспорте',
      toPlans: 'Тарифы',
    },
    boss: {
      kicker: 'Босс',
      desc: 'Граммозавр говорит твоими же ошибками из прошлых игр. Исправь фразу — нанесёшь удар. Три удара — победа.',
      open_one: '{{count}} твоя ошибка ждёт исправления',
      open_few: '{{count}} твои ошибки ждут исправления',
      open_many: '{{count}} твоих ошибок ждут исправления',
      open_other: '{{count}} твоих ошибки ждут исправления',
      noOwn: 'Своих ошибок пока нет — Граммозавр возьмёт типичные ошибки русскоязычных.',
      wins: 'Побед: {{n}}',
      resolved: 'Исправлено в боях: {{n}}',
      fight: 'В бой',
      resume: 'Продолжить бой',
    },
    mistakes: {
      kicker: 'Мои ошибки',
      title: 'Мои ошибки',
      count_one: '{{count}} запись',
      count_few: '{{count}} записи',
      count_many: '{{count}} записей',
      count_other: '{{count}} записи',
      cardText: 'Все поправки из историй, миссий и боёв: что не так, как лучше и почему.',
      sub: 'Все поправки из историй, миссий дня и боёв с боссом. Нажми на ошибку, чтобы прочитать, почему так.',
      open: 'Открыть',
      back: 'К карте',
      empty: 'Ошибок пока нет. Сыграй историю или миссию дня — ведущий разберёт каждый ответ.',
      filterLabel: 'Какие ошибки показать',
      filters: {
        all: 'Все',
        open: 'Не исправлены',
        grammar: 'Грамматика',
        pron: 'Произношение',
      },
      grammar: 'Грамматика',
      pron: 'Произношение',
      resolved: 'Исправлена в бою',
      repeats: 'Повторялась: {{n}}',
      sentence: 'Твой ответ',
      heard: 'Мы услышали',
      corrected: 'Как лучше',
      fightBoss: 'Сразиться с Граммозавром',
    },
    chapter: {
      kicker: 'Скоро',
      locked: 'Глава в работе',
      ask: 'Хочешь, чтобы она вышла скорее?',
      yes: 'Да, жду!',
      like: 'Нравится',
      thanks: 'Спасибо! Так мы понимаем, что делать первым.',
      cta: 'Хочу скорее',
      chosenYes: 'Ты ждёшь эту главу',
      chosenLike: 'Тебе нравится идея',
    },
    verify: {
      title: 'Подтверди почту\u00a0— и играй дальше',
      body: 'Откроем истории, бой с боссом и свои слова. Ссылка\u00a0— в письме, которое мы прислали при регистрации.',
      bodyTo: 'Откроем истории, бой с боссом и свои слова. Ссылка\u00a0— в письме на {{email}}.',
    },
    play: {
      back: 'К карте',
      goal: 'Цель',
      turn: 'ход {{n}} из {{total}}',
      round: 'Раунд {{n}} из {{total}}',
      turnShort: 'ход {{n}}/{{total}}',
      roundShort: 'раунд {{n}}/{{total}}',
      replay: 'Повторить',
      slow: 'Медленнее',
      thinking: '{{name}} думает',
      you: 'Ты',
      heard: 'Распознано',
      hints: 'Подсказка',
      hintsTitle: 'Можно ответить так — напиши своими словами или скажи вслух:',
      placeholder: 'Ответь по-английски…',
      placeholderBoss: 'Исправь фразу и отправь…',
      send: 'Отправить',
      mic: 'Ответить голосом',
      micStop: 'Готово',
      micCancel: 'Отмена',
      micDenied: 'Нет доступа к микрофону. Разреши его в настройках браузера или ответь текстом.',
      micUnsupported: 'Этот браузер не записывает голос — ответь текстом.',
      recording: 'Запись',
      results: 'Итоги',
      event: 'Событие',
      steps: 'Шаги миссии',
      allSteps: 'Все шаги выполнены',
      bossHp: 'Граммозавр',
      yourHp: 'Ты',
      hint: 'Подсказка: {{rule}}',
      showHint: 'Показать подсказку',
      mineTag: 'твоя ошибка',
      typicalTag: 'типичная ошибка',
      history: 'Ход разговора',
      howTitle: 'Как играть',
      how: 'Слушай персонажа и отвечай вслух — кнопка «Нажми и говори». Реплики текстом — по кнопке «Текст», ответить письменно — «Написать текстом». Голосовой ответ проверяется на грамматику и произношение, письменный — на грамматику. Разбор появится здесь после каждого ответа.',
      howBoss: 'Граммозавр говорит фразу с ошибкой — она уже в поле ответа. Исправь её и отправь или скажи правильно вслух. Попал — удар по боссу, промахнулся — минус сердце.',
      arenaLabel: 'Бой с Граммозавром у Тауэра',
      sceneLabel: 'Пиксельный Лондон: {{place}}',
      restartFailed: 'Начать заново',
      sendNow: 'Отправить сейчас',
      // Игра «говорят, а не пишут» (решение владельца 2026-10-22): голос персонажа, ответ голосом по умолчанию.
      speaking: '{{name}} говорит…',
      waiting: '{{name}} ждёт ответа',
      listen: 'Послушать',
      text: 'Текст',
      translate: 'Перевод',
      insertHint: 'Вставить',
      sceneWords: 'Слова',
      talk: 'Нажми и говори',
      talkShort: 'Говори',
      typeShort: 'Текстом',
      sending: 'Отправляем…',
      typeInstead: 'Написать текстом',
      voiceInstead: 'Отвечать голосом',
      hearing: 'Слышу тебя',
      speakNow: 'Говори…',
      micMissing: 'Микрофон не найден. Подключи его или ответь текстом.',
      // Микрофон занят другой программой (звонок) или сбой устройства (2026-10-30).
      micBusy: 'Микрофон сейчас занят другой программой. Закрой её и нажми ещё раз или ответь текстом.',
      resources: {
        money: 'Деньги',
        time: 'Время',
        battery: 'Заряд телефона',
        trust: 'Доверие',
        deadline: 'до {{time}}',
      },
      errors: {
        unavailable: 'Ведущий сейчас не отвечает. Прохождение не засчитано — попробуй ещё раз чуть позже.',
        voice: 'Не получилось разобрать голос. Скажи ещё раз чуть громче или напиши ответ.',
        rate: 'Слишком быстро. Подожди пару секунд и отправь снова.',
        generic: 'Не получилось отправить ответ. Проверь интернет и попробуй ещё раз.',
        // Ответ не ушёл из-за сети (2026-10-30): текст в поле, отправка — сама, когда связь вернётся.
        offline: 'Нет связи\u00a0— ответ не ушёл. Он в поле: отправим сами, когда связь вернётся.',
        resending: 'Связь вернулась\u00a0— отправляем ответ…',
        offlineVoice: 'Нет связи\u00a0— ответ не ушёл. Запись сохранена: отправим сами, когда связь вернётся.',
        finished: 'Эта игра уже закончилась.',
        notFound: 'Игра не найдена.',
        noTokens: 'Не хватает жетонов — новые придут в 00:00 по Москве.',
        verify: 'Сначала подтверди почту\u00a0— ссылка в письме.',
        guestLimit: 'Миссии без подтверждённой почты на сегодня закончились. Подтверди почту\u00a0— и играй дальше.',
      },
    },
    tactics: {
      polite: 'Вежливо',
      bargain: 'Торг',
      direct: 'Прямо',
      joke: 'Шутка',
      idea: 'Идея',
    },
    feedback: {
      title: 'Разбор ответа',
      clean: 'Без ошибок',
      fixes_one: '{{count}} поправка',
      fixes_few: '{{count}} поправки',
      fixes_many: '{{count}} поправок',
      fixes_other: '{{count}} поправки',
      notEnglish: 'Ответ не по-английски — персонаж не понял',
      notAnswered: 'Ответ не на вопрос — послушай реплику ещё раз',
      corrected: 'Как лучше сказать',
      why: 'Почему',
      lesson: 'Урок «{{title}}» →',
      yourAnswer: 'Твой ответ',
      pronTitle: 'Произношение',
      pronLine: 'Услышали «{{heard}}», а нужно «{{meant}}»',
      hit: 'Попадание!',
      miss: 'Мимо',
      right: 'Правильно',
      wholeBetter: 'Весь ответ правильно',
      effectsTitle: 'Что изменилось',
      fallback: 'Ведущий ответил запасной репликой — ход засчитан без разбора.',
      effects: {
        money: '{{sign}}£{{v}}',
        minutes: '+{{v}} мин',
        battery: 'заряд {{sign}}{{v}}%',
        trust: 'доверие {{sign}}{{v}}',
      },
    },
    // Окно «Поправки к ответу» (владелец 2026-10-25): правки, шпаргалка из урока и ссылка на урок.
    fixes: {
      kicker: 'Разбор ответа',
      cheat: 'Шпаргалка',
      open: 'Шпаргалка и уроки',
    },
    // Уровень ученика: спрашивает игра (владелец 2026-10-25, «для тех, кто учит с нуля»).
    level: {
      kicker: 'Выживи в Лондоне',
      title: 'Как у тебя с английским?',
      sub: 'Ведущий подстроится: с нуля — короткие простые фразы, перевод и подсказки, которые можно вставить.',
      change: 'Поменять можно на карте игры.',
      current: 'Твой английский: {{level}}',
      edit: 'изменить',
      choose: 'выбрать',
      zero: { title: 'С нуля', text: 'Знаю пару слов — нужен перевод и подсказки.' },
      basic: { title: 'Немного', text: 'Понимаю простые фразы и могу ответить коротко.' },
      confident: { title: 'Уверенно', text: 'Могу поговорить — нужна живая речь, как в жизни.' },
    },
    ending: {
      kicker: 'Концовка',
      secret: 'Секретная концовка',
      newEnding: 'Новая концовка!',
      stamps: 'Штампы',
      newStamp: 'новый',
      stats: {
        turns: 'ходов',
        fixes: 'поправок',
        voice: 'голосом',
      },
      words: 'Слова из игры',
      mistakes: 'Разбор ошибок',
      allMistakes: 'Все мои ошибки',
      noMistakes: 'Ни одной ошибки — так держать!',
      playAgain: 'Сыграть снова — новый сюжет',
      toMap: 'На карту',
    },
    dailyResult: {
      done: 'Миссия выполнена',
      partial: 'Почти получилось',
      none: 'В этот раз не вышло',
      next: 'Следующая миссия — завтра в 00:00 по Москве.',
      toBoss: 'Добить ошибки в бою с боссом',
    },
    bossResult: {
      win: 'Граммозавр повержен!',
      lose: 'Граммозавр победил',
      resolved: 'Исправлено твоих ошибок: {{n}}',
      openLeft: 'Осталось неисправленных: {{n}}',
      rounds: 'Раунды',
      again: 'Ещё бой',
    },
    bridge: {
      moduleName: 'Выживи в Лондоне',
      // Почта не подтверждена: слова видны, а в словарь — после подтверждения.
      locked: 'В словарь\u00a0— после подтверждения почты',
      add_one: 'Добавить {{count}} слово в словарь',
      add_few: 'Добавить {{count}} слова в словарь',
      add_many: 'Добавить {{count}} слов в словарь',
      add_other: 'Добавить {{count}} слова в словарь',
      adding: 'Добавляем…',
      added: 'Добавлено в модуль «{{name}}»',
      openModule: 'Открыть модуль',
      failed: 'Не получилось добавить слова. Попробуй ещё раз.',
      hint: 'Слова лягут в модуль «{{name}}» — их можно учить на тренировке.',
    },
    // Цена игр в жетонах (решение владельца 2026-10-22): на кнопке старта — «Играть · 2 жетона».
    price_one: '{{count}} жетон',
    price_few: '{{count}} жетона',
    price_many: '{{count}} жетонов',
    price_other: '{{count}} жетона',
    noTokens: 'Жетоны закончились',
    // Награда за миссию дня несгораемыми жетонами (решение владельца 2026-10-22): выполнена — +1, на три звезды — +2.
    reward: {
      doneTitle: 'Миссия выполнена',
      perfectTitle: 'Три звезды!',
      text_one: '+{{count}} несгораемый жетон уже на балансе.',
      text_few: '+{{count}} несгораемых жетона уже на балансе.',
      text_many: '+{{count}} несгораемых жетонов уже на балансе.',
      text_other: '+{{count}} несгораемых жетона уже на балансе.',
      got_one: 'Получен +{{count}} жетон',
      got_few: 'Получено +{{count}} жетона',
      got_many: 'Получено +{{count}} жетонов',
      got_other: 'Получено +{{count}} жетона',
      none: 'Жетоны не получены — их дают за прохождение миссии',
      offer_one: 'Пройди — +{{done}} жетон, без ошибок — ещё +{{extra}}',
      offer_few: 'Пройди — +{{done}} жетона, без ошибок — ещё +{{extra}}',
      offer_many: 'Пройди — +{{done}} жетонов, без ошибок — ещё +{{extra}}',
      offer_other: 'Пройди — +{{done}} жетона, без ошибок — ещё +{{extra}}',
    },
    // Цели игры на виду (владелец 2026-10-25): доп. цель и её статус.
    goals: {
      bonus: 'Доп. цель',
      dailyBonus_one: 'не больше 1 ошибки — ещё +{{count}} жетон',
      dailyBonus_few: 'не больше 1 ошибки — ещё +{{count}} жетона',
      dailyBonus_many: 'не больше 1 ошибки — ещё +{{count}} жетонов',
      dailyBonus_other: 'не больше 1 ошибки — ещё +{{count}} жетона',
      storyBonus: 'не больше 2 ошибок — +1 звезда',
      bossBonus: 'сохрани все жизни — 3 звезды',
      demoBonus: 'не больше 1 ошибки — 3 звезды',
      status: {
        on: 'пока получается',
        lost: 'упущена',
        done: 'выполнена',
      },
    },
    // Демо миссии без регистрации на /demo (решение владельца 2026-10-25).
    demo: {
      kicker: 'Демо миссии',
      badge: 'Выживи в Лондоне · демо',
      back: 'На сайт',
      // «‹» в игре демо — к стартовому экрану, а не на сайт (прогон тестировщика 28.10).
      backToIntro: 'Назад',
      signIn: 'Войти',
      // Уже вошёл — та же кнопка в шапке ведёт в игру.
      toGame: 'В игру',
      haveAccount: 'Уже есть аккаунт?',
      goal: 'Цель',
      turns_one: '{{count}} ответ',
      turns_few: '{{count}} ответа',
      turns_many: '{{count}} ответов',
      turns_other: '{{count}} ответа',
      voiceOrText: 'голосом или текстом',
      noSignUp: 'без регистрации',
      host: 'Повар ответит как живой, а после каждого ответа ведущий-ИИ покажет ошибки и объяснит их по-русски.',
      start: 'Начать миссию',
      starting: 'Готовим сцену…',
      // Вернулся из игры к выбору («‹»): игра продолжается, а не начинается заново.
      resume: 'Продолжить миссию',
      toResults: 'К итогам миссии',
      how_one: 'Ответь повару по-английски — голосом или текстом. У тебя {{count}} ответ: выполни шаги из цели.',
      how_few: 'Ответь повару по-английски — голосом или текстом. У тебя {{count}} ответа: выполни шаги из цели.',
      how_many: 'Ответь повару по-английски — голосом или текстом. У тебя {{count}} ответов: выполни шаги из цели.',
      how_other: 'Ответь повару по-английски — голосом или текстом. У тебя {{count}} ответа: выполни шаги из цели.',
      ctaTitle: 'Играй каждый день — бесплатно',
      ctaDaily_one: 'Новая миссия каждый день, за прохождение — до {{count}} жетона',
      ctaDaily_few: 'Новая миссия каждый день, за прохождение — до {{count}} жетонов',
      ctaDaily_many: 'Новая миссия каждый день, за прохождение — до {{count}} жетонов',
      ctaDaily_other: 'Новая миссия каждый день, за прохождение — до {{count}} жетона',
      ctaStory: 'Истории с разными концовками и бой с боссом из твоих же ошибок\u00a0— после подтверждения почты',
      ctaWords: 'Слова из игры — в карточки (после подтверждения почты), ошибки — в уроки грамматики',
      signUp: 'Создать аккаунт бесплатно',
      again: 'Сыграть ещё',
      learnWords_one: 'Создать аккаунт и учить {{count}} слово',
      learnWords_few: 'Создать аккаунт и учить {{count}} слова',
      learnWords_many: 'Создать аккаунт и учить {{count}} слов',
      learnWords_other: 'Создать аккаунт и учить {{count}} слова',
      learnWordsHint: 'Слова лягут в модуль «{{name}}» — тренируй сразу после регистрации.',
      mistakesHint: 'У ошибок со ссылкой — урок грамматики. Уроки бесплатны после регистрации.',
      wordsSaving: 'Добавляем слова из игры в модуль «{{name}}»…',
      wordsFailed: 'Не получилось добавить слова из игры. Их можно добавить вручную в «Словах и модулях».',
      // Главная: слова из демо не легли — попробуем при следующем заходе (2026-10-30).
      wordsRetry: 'Не получилось добавить слова из игры — попробуем ещё раз, когда вернёшься на главную.',
      toWords: 'К словам и модулям',
      wordsSaved: 'Слова из игры — в модуле «{{name}}». Можно учить!',
      wordsVerifyTitle: 'Подтверди почту — и слова сами лягут в модуль',
      wordsVerifyText: 'Слова из игры ждут: как только почта подтверждена, они появятся в модуле «{{name}}».',
      toHome: 'На главную',
      restart: 'Начать заново',
      closedTitle: 'Демо на сегодня закончились',
      closedText: 'Бесплатные демо на сегодня разобрали. Создай аккаунт — миссия дня бесплатна каждый день.',
      limitTitle: 'Демо на сегодня уже сыграно',
      limitText: 'Создай аккаунт — и играй каждый день: новая миссия, истории и бой с боссом.',
      loadFailed: 'Не получилось загрузить миссию. Проверь соединение и попробуй ещё раз.',
      errors: {
        expired: 'Это демо закончилось или устарело.',
        busy: 'Повар ещё отвечает на прошлую фразу.',
        unavailable: 'Ведущий сейчас не отвечает. Демо не засчитано — начни заново чуть позже.',
        start: 'Не получилось начать демо. Попробуй ещё раз.',
      },
    },
    // Над ответом в игре: подключён ли микрофон и есть ли звук (решение владельца 2026-10-22).
    devices: {
      mic: {
        checking: 'Проверяем микрофон…',
        ready: 'Микрофон подключён',
        prompt: 'Микрофон: нужно разрешение',
        denied: 'Микрофон запрещён',
        missing: 'Микрофон не найден',
        busy: 'Микрофон занят другой программой',
        unsupported: 'Браузер не записывает голос',
      },
      micNamed: 'Микрофон: {{name}}',
      speaker: {
        checking: 'Проверяем звук…',
        ready: 'Звук включён',
        missing: 'Нет динамиков или наушников',
        unknown: 'Звук',
      },
      speakerNamed: 'Звук: {{name}}',
      allow: 'Разрешить',
      retry: 'Ещё раз',
      test: 'Проверить',
      tested: 'Слышно сигнал?',
      // Браузер отказал без запроса — где включить именно здесь (владелец 2026-10-31).
      // По браузеру и тому, как открыта игра (micHelp.ts, владелец 2026-10-31).
      help: {
        inApp: 'Браузер внутри приложения не даёт микрофон. Открой Lomora в обычном браузере: меню ⋯ в углу → «Открыть в браузере».',
        androidChromeApp: 'Браузер не даёт микрофон. Открой Chrome → ⋮ → Настройки → Настройки сайтов → Все сайты → {{host}} → Микрофон → Разрешить: приложение берёт разрешения из Chrome.',
        androidChrome: 'Chrome не даёт микрофон. Открой ⋮ → Настройки → Настройки сайтов → Все сайты → {{host}} → Микрофон → Разрешить.',
        androidSamsung: 'Samsung Internet не даёт микрофон. Открой ≡ → Настройки → Сайты и загрузки → Разрешения сайтов → Микрофон → {{host}} → Разрешить.',
        androidYandex: 'Яндекс Браузер не даёт микрофон. Открой меню браузера → Настройки → разрешения сайтов → Микрофон → {{host}} → Разрешить. Не помогло — Настройки телефона → Приложения → Яндекс Браузер → Разрешения → Микрофон.',
        androidFirefox: 'Firefox не даёт микрофон. Нажми на замок в адресной строке → разрешения → Микрофон → разреши. Или ⋮ → Настройки → Разрешения сайтов.',
        android: 'Браузер не даёт микрофон. Открой меню браузера → Настройки → разрешения сайтов → Микрофон → {{host}} → Разрешить.',
        iosApp: 'Браузер не даёт микрофон. Открой Настройки iPhone → Safari → Микрофон → «Разрешить» или «Спросить», затем закрой и снова открой Lomora.',
        iosSafari: 'Safari не даёт микрофон. Нажми «аА» в адресной строке → Настройки веб-сайта → Микрофон → Разрешить.',
        iosOther: 'Браузер не даёт микрофон. Открой Настройки iPhone → Конфиденциальность и безопасность → Микрофон → включи свой браузер.',
        desktopApp: 'Браузер не даёт микрофон. Нажми ⋮ в правом верхнем углу окна Lomora → сведения о приложении → Микрофон → Разрешить.',
        desktopYandex: 'Яндекс Браузер не даёт микрофон. Нажми на значок слева от адреса → включи «Микрофон» → «Обновить страницу».',
        desktopFirefox: 'Firefox не даёт микрофон. Нажми на перечёркнутый микрофон слева от адреса, убери запрет и обнови страницу.',
        desktopSafari: 'Safari не даёт микрофон. В меню Safari → «Настройки для {{host}}» → Микрофон → Разрешить.',
        desktop: 'Браузер не даёт микрофон. Нажми на значок слева от адреса сайта → Микрофон → Разрешить.',
      },
    },
    // Лоадер старта игры: ведущий пишет первую сцену и озвучку (2026-10-22).
    preparing: {
      daily: 'Готовим миссию…',
      story: 'Готовим историю…',
      boss: 'Готовим бой…',
    },
  },
  // Админка: блок «Истории» (2026-10-22).
  adminStories: {
    title: 'Истории',
    sub: 'Игра «Выживи в Лондоне»: открывают ли, доходят ли до концовки, перепроходят ли и сколько это стоит. Без тестовых аккаунтов и админов.',
    opened: 'Открыли вкладку',
    openedSub: 'учеников за период',
    started: 'Начали историю',
    startedSub: 'прохождений {{runs}}, до концовки {{finished}}',
    replay: 'Перепрошли',
    replaySub: '2+ прохождения · {{share}} начавших',
    endings: 'Концовки',
    dropped: 'Где бросают',
    droppedHint: 'ход, на котором остановились',
    turn: 'Ход {{n}}',
    more: 'Ещё',
    avgTurns: 'Ходов до концовки',
    voiceShare: 'Ответов голосом',
    fallbacks: 'Запасных ходов',
    interest: 'Ждут главу 2',
    interestValue: 'да {{yes}} · лайк {{like}}',
    daily: 'Миссия дня',
    dailyValue: '{{users}} уч. · {{runs}} · выполнено {{done}}',
    boss: 'Босс',
    bossValue: '{{users}} уч. · боёв {{fights}} · побед {{wins}} · исправлено {{resolved}}',
    tokens: 'Токены ведущего (вход / выход)',
    tts: 'Озвучено символов',
    ttsValue: '{{period}} за период · {{week}} за 7 дней',
    empty: 'Пока никто не играл.',
    eleven: {
      left: 'Кредиты ElevenLabs',
      of: 'из {{limit}}',
      resets: 'обновятся {{date}}',
      tier: 'тариф {{tier}}',
      low: 'мало — новые реплики голосом браузера',
      notConfigured: 'Ключ не задан — реплики без озвучки.',
      error: 'ElevenLabs не ответил ({{error}}).',
    },
    // Демо без регистрации (/demo, 2026-10-25): сколько в день и докуда доходят.
    demo: {
      title: 'Демо без регистрации',
      hint: 'до {{perIp}} с адреса в день · {{turns}} ответов',
      today: 'Сегодня',
      todayValue: '{{n}} из {{limit}}',
      started: 'Начато',
      finished: 'До конца',
      done: 'Все шаги',
      voice: 'Голосом',
      avgTurns: 'Ответов',
      day: 'День',
      byDay: 'Демо по дням',
      empty: 'Демо пока не начинали.',
    },
    endingNames: {
      view_room: 'Номер с видом',
      mia_sofa: 'Диван у Мии',
      hostel: 'Хостел на 12 коек',
      cafe_dawn: 'Кафе до рассвета',
      station_night: 'Ночь на вокзале',
      upgrade: 'Апгрейд до люкса',
    },
  },
};

export type RuMessages = typeof ru;
